"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _4d_mapper_1 = require("4d-mapper");
const drag_drop_1 = require("@angular/cdk/drag-drop");
const core_1 = require("@angular/core");
const material_1 = require("@angular/material");
const router_1 = require("@angular/router");
const core_2 = require("@ngx-translate/core");
const await_class_1 = require("@src/app/xs/controllers/await.class");
const incoming_data_service_1 = require("@src/app/xs/services/data/incoming-data.service");
const application_events_service_1 = require("@src/app/xs/services/events/application-events.service");
const ui_manager_service_1 = require("@src/app/xs/services/ui/ui-manager.service");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const acl_service_1 = require("../../../commons/acl/acl.service");
const app_service_1 = require("../../../commons/app.service");
const BaseComponent_1 = require("../../../commons/BaseComponent");
const Constants_1 = require("../../../commons/Constants");
const explorer_dialogs_1 = require("../../../commons/dialogs/explorer.dialogs");
const map_service_1 = require("../../../commons/map.service");
const plugins_1 = require("../../../commons/plugins/plugins");
const States_1 = require("../../../commons/States");
const scene_controller_service_1 = require("../../../service/controllers/scene-controller.service");
const measurement_helper_service_1 = require("../../../service/measurement-helper.service");
const plugin_manager_service_1 = require("../../../service/plugin-manager.service");
const map_data_service_1 = require("../../../v2/commons/map-data.service");
const stream_data_service_1 = require("../../../v2/commons/stream-data.service");
const main_service_1 = require("../../main.service");
const map_component_1 = require("../map.component");
const bucket_action_controller_1 = require("./../../../commons/plugins/buckets/bucket-action-controller");
const Cesium = window.Cesium;
class LayersListComponent extends BaseComponent_1.BaseComponent {
    constructor(_injector, route, router, fourD, snackBar, dialog, mapService, uiManager, incomingData, permissions, service, streams, pluginManager, mainService, translate, v2MapDataService, measureHelper, applicationEvents, sceneController) {
        super(router, snackBar, dialog);
        this._injector = _injector;
        this.route = route;
        this.router = router;
        this.fourD = fourD;
        this.mapService = mapService;
        this.uiManager = uiManager;
        this.incomingData = incomingData;
        this.permissions = permissions;
        this.service = service;
        this.streams = streams;
        this.pluginManager = pluginManager;
        this.mainService = mainService;
        this.translate = translate;
        this.v2MapDataService = v2MapDataService;
        this.measureHelper = measureHelper;
        this.applicationEvents = applicationEvents;
        this.sceneController = sceneController;
        this.debug = Constants_1.Constants.debug_off;
        this.debugPrimary = Constants_1.Constants._green;
        this.debugSecondary = Constants_1.Constants._gray;
        // is this layers(?) loading (which I think means scene? @Haresh)
        this.loading = false;
        // are we editing the scene
        this.editing = false;
        // are we viewing a splitting? (side-by-side compare of two images)
        this.splitting = false;
        // generic Cesium helper class
        // cesiumHelper: FourdCesiumHelper;
        this.cItem = null;
        // items / Transforms plotted to the map
        // moved to the scene controller -- plottedItems: Transform[] = [];
        // reference to the CSS show/hide component
        this.$ = Constants_1.Constants.HANG_ON;
        // What does this one do? @Haresh
        this._saveSubj = new rxjs_1.Subject();
        // What's this used for? @Haresh
        this._saveObj = this._saveSubj.asObservable().pipe(operators_1.debounceTime(3000));
        // Why is this here? @Haresh
        this.TERRAIN_COLORIZED_MESSAGE = 'Terrain is colorized. Please disable it.';
        // What is this for? Why is it here? @Haresh
        this.scenTimeout = 5000;
        this.kmlDataSource = [];
        this.me = this;
        // reference to the map
        // private mapComp: MapComponent
        this.mapComponent = null;
        // sceneMeta (meta object used as an anchor for plugins that are linked to a static scene object with events for updates)
        this.metaScene = {
            __guid: '114f16e2-b093-4e54-ae0a-345c3ce8cf74',
            id: '9999999999',
        };
        // current serving what scene?
        this.currentSceneGuid = null;
        // all jobs associated with this scene
        this.currentSceneJobs = [];
        // show jobs?
        this.showJobs = false;
        // show the scene's files?
        this.showSceneFiles = false;
        this.showLegends = false;
        this.sceneFolder = null;
        this.sceneFiles = null;
        this.sceneFilesChecked = false;
        this.virtualSceneFiles = [];
        this.virtualSceneFilesChecked = false;
        this.allAdditionalFiles = [];
        this.uploadDragHover = false;
        // we've got plugin controllers!
        // for all transforms in a scene
        this.transformPlugins = null;
        // for all plugins *for* the scene
        // scenePlugins:PluginController = null;
        // control plugins that list things (guides, jobs, files, whatever)
        this.sceneBuckets = null;
        this.isBasemapActive = false;
        // track state of hovering plugin menus
        this.pluginHover = {};
        this.sceneTransformsById = {};
        this.sceneTransformsByType = {};
        this.sceneTransformsByCategory = {};
        this.sceneTransforms = [];
        this.sceneTransformsActive = [];
        this.sceneTransformsActiveViews = {};
        this.sceneFirstTransformNotTerrainModel = null;
        this.sceneTerrainModels = [];
        this.sceneSelectedTerrainModel = null;
        this.plugindebug = null;
        // view mode (for when we're using the splitViewer)
        // inSplitMode:boolean = false;
        this.splitViewer = null;
        this.tileProfiler = null;
        // canSplit:boolean = false;
        // temporary
        this.selectedEntityRendered = null;
        // a local cache of plugins to speed things up
        this.localPluginControllerCache = {};
        // popslider is a slider that pops up when you hover over certain icons
        this.popslider = null;
        this._c = 'background-color:purple;color:white;font-weight:bold;font-size:14px;padding:2px 3px;';
        this.removeTransformPlugins = false;
        this.cc = 0;
        this.contactUsRequest = null;
        this.contactUsShow = false;
        this.contactUsState = 'ready';
        this.contactUsMessage = '';
        // we need a deletePlugin() because we need to check if some plugins have a entitiesDirty flag set
        // if true, we need to uncheck, then check (enforcing a reload of the entities) before we delete the plugin
        /*
        preRemoveTransformPlugin ( pluginId:any ) {
      
          let plugin = this.pluginManager.get ( pluginId );
      
          // if the popover is active, close it
          this.deactivatePluginPopover();
      
          // is it dirty? (ie. does it need a reset after the plugin is removed?)
          if ( plugin.entitiesDirty ) {
            this.resetTransform(plugin.item);
          }
      
        }
      
        preRemoveScenePlugin ( pluginId:any ) {
      
          // if the popover is active, close it
          this.deactivatePluginPopover();
      
        }
      */
        /*
        deletePlugin ( id:string, item:any = null, butDontDeleteSavedInfo:boolean = false ) {
      
          // if the popover is active, close it
          this.deactivatePluginPopover();
      
          console.log('@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ 1 ');
      
          if ( this.pluginManager.check(id) ) {
      
            // get the details of the plugin
            let p = this.pluginManager.get(id);
            if ( p ) {
      
              // is it dirty? (ie. does it need a reset after the plugin is removed?)
              if ( p.entitiesDirty ) {
                this.resetTransform(p.item);
              }
      
              // created through a controller?
              if ( p.controller ) {
      
                console.log('@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ 2 ');
                // let the controller know
                p.controller.delete(id);
      
              }
            }
      
          }
        }
      */
        /*
        clickPluginShortcut ( plugin:any, item:any, event:any = null ) {
      
          let me = this;
      
          if ( plugin.active ) {
      
            // already running
            this.activatePluginPopover(plugin, item, event);
      
          } else {
      
            // not running; start one up
            plugin.id = this.transformPlugins.create(plugin.name,null,item);
      
            setTimeout( () => { me.activatePluginPopover(plugin, item, event); }, 200 );
      
          }
        }
      
        activatePluginPopover ( plugin:any, item:any, event:any = null ) {
      
          let p = this.pluginManager.get(plugin.id);
      
          this.selected_item = item;
          this.selected_plugin = p;
      
          let find = ('plugin-ui-' + plugin.id).trim();
      
          let pop = document.getElementById('plugin-popover');
          if ( pop ) {
            if ( event.clientY ) {
              let y:number = (event.clientY + 15);
              // let pos:number = (document.documentElement.scrollTop || document.body.scrollTop) + document.documentElement.offsetHeight;
              let max:number = document.documentElement.scrollHeight;
      
              if ( max - y < 310 ) {
                y = max - 310;
              }
              pop.style.top = y + 'px';
              
              // give it some time for the sub-components to draw their content
              setTimeout( () => {
      
                let box = document.getElementById(find);
                if ( box ) {
                  box.style.maxHeight =  (max - y) - 50 + 'px';
                }
                // console.log('@@@', y, pos, max, (max - y) - 50, find );
      
              }, 100 );
            }
          }
        }
      
        deactivatePluginPopover() {
          
          this.selected_item = null;
          this.selected_plugin = null;
      
          console.log('deactivate', this.selected_item, this.selected_plugin );
      
        }
      
      */
        // Preserve original property order
        this.originalOrder = (a, b) => {
            return 0;
        };
        // Order by ascending property value
        this.valueAscOrder = (a, b) => {
            return a.value.localeCompare(b.value);
        };
        // Order by descending property key
        this.keyDescOrder = (a, b) => {
            return a.key > b.key ? -1 : b.key > a.key ? 1 : 0;
        };
        this.checkEntities = true;
        this.entityTypes = [
            '_name',
            '_description',
            '_polygon',
            '_polyline',
            '_billboard',
            '_point',
            '_label',
            '_corridor',
            '_cylinder',
            '_ellipse',
            '_path',
            '_plane',
            '_position',
            '_rectangle',
            '_wall',
            '_tileset',
        ];
        this.checkProperties = true;
        // access to parent / MapComponent with injectors instead of old passing in stuff ...
        this.mapComponent = this._injector.get(map_component_1.MapComponent);
        this.splitViewer = this.mapComponent.splitViewer;
        this.tileProfiler = this.mapComponent.tileProfiler;
        // this.transformPlugins = this.mapComponent.transformPlugins;
        this.initPluginControllers();
        const me = this;
        setTimeout(() => {
            me.splitViewer = me.mapComponent.splitViewer;
            me.tileProfiler = me.mapComponent.tileProfiler;
        }, 5000);
    }
    dragDropControl(e, entering) {
        this.uploadDragHover = entering;
        e.preventDefault();
        e.stopPropagation();
    }
    ngAfterViewInit() {
        this.splitViewer = this.mapComponent.splitViewer;
        this.tileProfiler = this.mapComponent.tileProfiler;
    }
    togglePopslider(n = null, opac = null) {
        this.popslider = n;
        // console.log('## popslider', n, opac);
    }
    toggleBasemap(b) {
        this.mapService.showBaseModel(b.checked);
        this.mapService.scene['baseModel'] = b.checked;
        this.mapService.scene.saveObservable().subscribe();
    }
    toggleSplitView() {
        // console.log("##TOGGLE",this.mapComponent.splitViewer.isSplitting);
        this.splitViewer = this.mapComponent.splitViewer;
        this.splitViewer.isSplitting ? this.splitViewer.stop() : this.splitViewer.start(this.mapService.scene);
    }
    toggleTileProfiler() {
        this.tileProfiler = this.mapComponent.tileProfiler;
        this.tileProfiler.profilerActive ? this.tileProfiler.stop() : this.tileProfiler.start(this.mapService.scene);
    }
    initPluginControllers() {
        let me = this;
        // console.log ( "================================================================================================", this.transformPlugins, this.sceneBuckets );
        // we got two points where we control plugins
        // the current scene
        /*
        if ( ! this.scenePlugins ) {
          this.scenePlugins = this.pluginManager.createController ( 'scene', {
            label: 'Scene plugins',
            filterByType: [ FdmPlugin.types.sceneController ],
            createId: function ( item:any ) {  return 's_' + item.id; },
            preRemove: function ( pluginId:any ) {
              me.deactivatePluginPopover();
            }
          });
        }
        */
        // our transforms
        if (!this.transformPlugins) {
            this.transformPlugins = this.pluginManager.createController('transforms', {
                filterByType: [plugins_1.FdmPlugin.types.transformController],
                filterByItemDsType: true,
                filterByItemTrType: true,
                createId: function (item) {
                    return 't_' + item.id;
                },
                preRemove: function (pluginId, isDelete) {
                    // let plugin = me.pluginManager.get ( pluginId );
                    // if the popover is active, close it
                    if (me.transformPlugins.component) {
                        me.transformPlugins.component.close();
                    }
                    // is it dirty? (ie. does it need a reset after the plugin is removed?)
                },
            });
        }
        // we also have some buckets of information
        if (!this.sceneBuckets) {
            this.sceneBuckets = this.pluginManager.createController('buckets', {
                filterByType: [plugins_1.FdmPlugin.types.bucketsController],
                createId: function (item) {
                    return 'bs_' + item.id;
                },
            });
            // first bucket is full of camera positions
            this.sceneBuckets.addController({
                name: 'cameras',
                type: 'bucket-handler',
                languageToken: 'TOUR_GUIDE',
                controller: new bucket_action_controller_1.BucketActionController({
                    object: this.mapService.scene,
                    structure: '__cameras',
                    showNavigation: true,
                    bucketActions: [
                        {
                            name: 'add',
                            icon: 'webcam',
                            tooltip: 'PLUGINS.BUCKET.TOUR_GUIDE.ADD',
                            getData: function () {
                                return me.sceneController.getCamera();
                            },
                        },
                    ],
                    itemActions: [{ name: 'delete', icon: 'trash', tooltip: 'PLUGINS.BUCKET.TOUR_GUIDE.DELETE' }],
                    itemSelect: function (item) {
                        me.sceneController.flyToCamera(item.data);
                    },
                }),
            });
            /*
            // second bucket is full of data feeds
            let feedsId = this.sceneBuckets.addController ({
              name: 'feeds',
              type: 'bucket-handler',
              languageToken: 'FEEDS',
              controller: new BucketActionController({
                showCallback: new Cesium.CallbackProperty( () => {
                    // console.log('#callBack',this);
                    return this.pluginManager ? this.pluginManager.pluginCategories.find( f => f == 'PLUGINS.CATEGORY.ADVANCED') : false;
                }, false),
                // show: new XsLiveCheckProperty({ parent:this.pluginManager, array:'pluginCategories', find:'PLUGINS.CATEGORY.ADVANCED' }),
                object: this.mapService.scene,
                structure: '__feeds',
                bucketActions: [{ name:'add', icon: 'rss' },{ name:'refresh', icon:'redo-alt' }],
                itemActions: [{ name:'delete', icon:'trash' },{ name:'edit', icon:'edit' }],
                itemSelect: function( item ) { }
              }),
            });
            let feeds = this.pluginManager.get(feedsId);
            // console.log('####FEEDS', feedsId, feeds, feeds['actionController'] );
      */
        }
        // console.log ( "--------------------------------------------------------------------------------------------", this.pluginManager.pluginCategories, this.pluginManager.pluginCategories['PLUGINS.CATEGORY.ADVANCED'] );
        this.plugindebug = {
            byCardinality: this.pluginManager.registryByCardinality,
            byCategory: this.pluginManager.registryByCategory,
            byType: this.pluginManager.registryByType,
            byDsType: this.pluginManager.registryByDsType,
        };
    }
    // let's all click the 'add data' button
    clickAddData() {
        const el = document.getElementById('add-data-button');
        if (el) {
            el.click();
        }
    }
    clickPhotoBucket() {
        setTimeout(() => {
            this.mapComponent.togglePhotoBucket();
        }, 60);
    }
    clickToggleViewDetails(item) {
        // if we're about to open something, close all other
        if (!item.showOptions) {
            this.sceneTransforms.forEach((t) => {
                t['showOptions'] = false;
            });
        }
        item.showOptions = !item.showOptions;
    }
    totalFiles() {
        let sf = this.sceneFiles ? this.sceneFiles : [];
        let vsf = this.virtualSceneFiles ? this.virtualSceneFiles : [];
        this.allAdditionalFiles = [
            ...sf.filter((d) => !d.dataType || d.dataType.uid != 'photo'),
            ...vsf.filter((d) => !d.dataType || d.dataType.uid != 'photo'),
        ];
    }
    resetTransform(t) {
        this.sceneController.resetTransform(t).then((_) => {
            t['__issues'] = {};
            this.mapService.reorderTransform();
            this.checkAndConfigureFeatures(t);
            this.updateItem(t, this._saveSubj);
        });
    }
    humanFileSize(bytes, si = true, dp = 1) {
        const thresh = si ? 1000 : 1024;
        if (Math.abs(bytes) < thresh) {
            return bytes + ' B';
        }
        const units = si ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
        let u = -1;
        const r = Math.pow(10, dp);
        do {
            bytes /= thresh;
            ++u;
        } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);
        return bytes.toFixed(dp) + ' ' + units[u];
    }
    updateAdditionalFiles() {
        // console.log ( '%c layers.comp %c updateAdditionalFiles() start', this.debugPrimary, this.debugSecondary, this.mapService.scene );
        // scene files
        this.fourD.V.searchByObject(_4d_mapper_1.Folder)
            .equals('forScene', this.mapService.scene)
            .limit(100008)
            .queryObservable()
            .subscribe((fo_res) => {
            if (fo_res && fo_res.items && fo_res.items[0]) {
                this.sceneFolder = fo_res.items[0];
                // console.log ( '%c layers.comp %c updateAdditionalFiles() scene FOLDER', this.debugPrimary, this.debugSecondary, this.sceneFolder, fo_res );
                // this.fourD.V.searchByObject(Dataset).equals('folder', scene.folder).greaterThan('dateUpdated', me ).sortBy('dateUpdated', true).limit(878).queryObservable().subscribe(value => {
                this.fourD.V.searchByObject(_4d_mapper_1.Dataset)
                    .equals('folder', this.sceneFolder)
                    .sortBy('dateUpdated', true)
                    .limit(100009)
                    .queryObservable()
                    .subscribe((fi_res) => {
                    let final = [];
                    let noneOfThese = [];
                    // console.log("@@@@@", this.mapService.sceneTransforms);
                    // if a Transform has an input, it means there's a link between the Transform and a Dataset (ie. this is not an additional file; it's an actual file with a Transform)
                    this.mapService.sceneTransforms.forEach((t) => {
                        if (t['input']) {
                            noneOfThese.push(t['input'].id);
                        }
                    });
                    this.mapService.scenePhotos.forEach((t) => {
                        if (t['input']) {
                            noneOfThese.push(t['input'].id);
                        }
                    });
                    if (fi_res && fi_res.items) {
                        fi_res.items.forEach((d) => {
                            let test = noneOfThese.find((any) => any == d.id);
                            // console.log('# test ['+d.id+']', d, test );
                            if (!test) {
                                final.push(d);
                            }
                        });
                        // if ( this.debug ) { console.log ( '%c layers.comp %c updateAdditionalFiles() scene FILES', this.debugPrimary, this.debugSecondary, fi_res.items ); }
                        // console.log ( '%c layers.comp %c updateAdditionalFiles() scene FILES', this.debugPrimary, this.debugSecondary, fi_res.items, noneOfThese, final, fi_res );
                        this.sceneFiles = final;
                        this.sceneFilesChecked = true;
                        this.totalFiles();
                    }
                });
            }
        });
        // virtual files
        if (this.mapService.scene.folder && this.mapService.scene.folder.linkedFiles) {
            this.mapService.scene.folder.linkedFiles
                .limit(100010)
                .queryObservable()
                .subscribe((files) => {
                if (this.debug) {
                    console.log('%c layers.comp %c updateAdditionalFiles() VIRTUAL files', this.debugPrimary, this.debugSecondary, files.items);
                }
                if (files.items && files.items.length > 0) {
                    let items = files.items;
                    items.forEach((i) => (i['isVirtual'] = true));
                    this.virtualSceneFiles = items;
                    this.virtualSceneFilesChecked = true;
                    this.totalFiles();
                }
            });
        }
    }
    percent(max, current) {
        return 100 - Math.floor((current * 100) / max);
    }
    removeLinkedFile(file) {
        if (this.virtualSceneFiles && this.virtualSceneFiles.length > 0) {
            this.virtualSceneFiles = this.virtualSceneFiles.filter((f) => f.id !== file.id);
        }
        this.totalFiles();
        this.mapService.scene.folder.linkedFiles.removeObservable(file).subscribe((_) => {
            if (this.debug) {
                console.log('%c layers.comp %c removeLinkedFile() ', this.debugPrimary, this.debugSecondary);
            }
            this.mapService.scene.fetchObservable().subscribe();
            this.updateAdditionalFiles();
        });
    }
    saveLayerName(layer, newName) {
        if (layer && layer.name != newName) {
            layer.name = newName;
            this._subs.push(layer.saveObservable().subscribe());
        }
    }
    init() {
        // console.log('@@@@@@@@@@@@@@@ layers @@@@@@@@@@@@@ waiting for ...', { object: this.mapService, children: ['viewer','helper'] } );
        await_class_1.XsAwait.until(['mapService.viewer', 'mapService.helper'], this).then((_) => {
            // console.log('@@@@@@@@@@@@@@@ layers @@@@@@@@@@@@@ THESE are OK', theseOnes );
            this.safeInit();
        });
    }
    // whenever a scene is about to change; reset the plugin controllers
    ___sceneChangeInit(scene) {
        // console.log('%c **** layer ; scene about to change (reset stuff)', this._c, scene );
        // console.log('%c **** layer ; scene change INIT', this._c, scene );
        this.localPluginControllerCache = {
            basemap: this.mapComponent.basemapPlugins,
            environment: this.mapComponent.cameraPlugins,
        };
        // make sure we've got our plugin controllers
        this.initPluginControllers();
        // remove any plugins in the scene or on a transform
        if (!this.removeTransformPlugins) {
            this.transformPlugins.removeAll();
        }
        // if you 'tell' the controllers, they will empty out their own trash...
        // this.sceneBuckets.emptyAllControllers();
        if (this.splitViewer) {
            this.splitViewer.stop();
        }
        if (this.tileProfiler) {
            this.tileProfiler.stop();
        }
    }
    ___sceneChangeStart(scene = null) {
        // console.log('%c **** layer ; scene change START', this._c, scene );
        this.transformsOrderAndGroup();
    }
    // scene has changed; regroup the transforms, and tell various controllers that things have changed around here ...
    ___sceneChangeEnd(scene) {
        // console.log('%c **** layer ; scene change END', this._c, scene );
        // tell all bucket controllers about the new scene
        this.sceneBuckets.tellControllers('update', scene);
        this.splitViewer = this.mapComponent.splitViewer;
        this.splitViewer.updateSplitView(scene);
        this.tileProfiler = this.mapComponent.tileProfiler;
        this.tileProfiler.updateTransforms(scene);
        // group our Transforms according to type (Terrains vs. everything else)
        this.transformsOrderAndGroup();
        // setTimeout ( () => { this.splitViewer.stop(); this.transformsOrderAndGroup(); }, 6000 );
    }
    // whenever a transform has unplotted itself from the map
    ___unplotTransformInit(t) {
        // console.log('%c **** ___T unplotting', this._c, t.id, t );
        if (!this.removeTransformPlugins) {
            this.transformPlugins.removeAllFromItem(t);
        }
    }
    // whenever a transform has unplotted itself from the map
    ___unplotTransform(t) {
        // console.log('%c **** ___T unplotted (DONE)', this._c, t.id, t );
    }
    // whenever a transform has plotted itself on the map
    ___plotTransform(t) {
        // console.log('%c **** ___T plotted (loading from item)', this._c, t.id, t['__detected'] );
        // update any additional features of the item (contrast, wireframe, opacity, etc.)
        this.updateItem(t, this._saveSubj);
        // load in any plugins for the transforms (if saved to them)
        if (!this.removeTransformPlugins) {
            // console.log('%c ############ LOAD PLUGINS ', Constants._orange, t, this.mapService.scene.id );
            this.transformPlugins.loadFrom(t, this.mapService.scene.id);
        }
    }
    safeInit() {
        this.splitViewer = this.mapComponent.splitViewer;
        this.tileProfiler = this.mapComponent.tileProfiler;
        this.localPluginControllerCache = {
            basemap: this.mapComponent.basemapPlugins,
            environment: this.mapComponent.cameraPlugins,
        };
        if (this.debug) {
            console.log('%c layers.comp %c init()', this.debugPrimary, this.debugSecondary);
        }
        this.addSubscription('streamEvent', this.streams.sceneEvents.pipe(operators_1.filter((s) => s.item == this.mapService.scene)).subscribe((ev) => {
            if (this.debug) {
                console.log('%c layers.comp %c Stream Event ' + ev.event, this.debugPrimary, this.debugSecondary, ev.item);
            }
        }));
        this.addSubscription('streamFileEvents', 
        // this is a quick fix, refreshing all files will result in an API call
        // this is a socet event with the particulars of the file thats just changed, why
        // would it (and all other files) get re-requested?
        // A jpeg will throw this several times, befin, mid end upload beging and end processing
        this.streams.fileEvents.pipe(operators_1.debounceTime(400)).subscribe((s) => {
            // Listen to file updates events to refresh the additional files section
            if (s.event == 'UPDATE') {
                this.updateAdditionalFiles();
            }
        }));
        // put the saving of the scene on a debounce so it doesnt save every time someone adjust s a transparency
        this.addSubscription('savingScene', this._saveObj.subscribe((_) => {
            if (this.debug) {
                console.log('layers.comp :: sub :: saveObservable');
            }
            if (this.mapService.scene) {
                this.mapService.scene.saveObservable().subscribe();
            }
        }));
        /*
    
        let _c = 'background-color:purple;color:white;font-weight:bold;font-size:14px;padding:2px 3px;';
    
        this.addSubscription(
          this.applicationEvents.when('sceneChangeInit').subscribe ( _ => {
    
            console.log('%c **** scene about to change (reset stuff)', _c );
    
            // make sure we've got our plugin controllers
            me.initPluginControllers();
    
            // remove any plugins in the scene or on a transform
            me.transformPlugins.removeAll();
            me.sceneController.clearScene();
    
            // inject a new perimeter-handler
            // this.scenePlugins.create ( 'perimeter-handler',{ name:'perimeter' });
          
          })
        );
    
        this.addSubscription(
          this.applicationEvents.when('sceneChange').subscribe ( scene => {
    
            console.log('%c **** scene changed', _c, scene );
    
            // group our Transforms according to type (Terrains vs. everything else)
            me.regroupTransforms();
    
            // tell all bucket controllers about the new scene
            me.sceneBuckets.tellControllers ( 'update', scene );
    
          })
        );
    
        this.addSubscription(
          this.applicationEvents.when('unplotTransform').subscribe ( t => {
    
            console.log('%c **** T unplotted (should delete plugins)', _c, t.id, t );
            // console.log('%c **** T unplotted (active plugins)', _c, me.transformPlugins.listActive(t) );
    
            me.transformPlugins.removeAllFromItem( t );
          })
        );
    
        me.addSubscription(
          me.applicationEvents.when('plotTransform').subscribe ( t => {
            
            console.log('%c **** T plotted (loading from item)', _c, t.id, t );
    
            // update any additional features of the item (contrast, wireframe, opacity, etc.)
            me.updateItem(t, me._saveSubj);
    
            // load in any plugins for the transforms (if saved to them)
            me.transformPlugins.loadFrom( t, me.mapService.scene.id );
            
          })
        );
    */
        // old subscription here
        this.addSubscription('onSceneChange', 
        // when the scene has changed (loaded different, or a brand new one)
        this.mapService.onSceneChange('layers.component').subscribe((scene) => {
            if (this.debug) {
                console.log('%c layers.comp :: sub %c NEW SCENE', this.debugPrimary, this.debugSecondary, scene, this.mapService.sceneTransforms);
            }
            // this.loading = false;
            this.sceneFolder = null;
            this.sceneFiles = null;
            this.sceneFilesChecked = false;
            this.virtualSceneFiles = [];
            this.virtualSceneFilesChecked = false;
            if (this.mapService.scene) {
                this.sceneName = this.mapService.scene.name;
                // console.log ( '@@@@@@@@@@@@@@@@@@@@@@@@@@', this.mapService.scene);
                if (this.debug) {
                    console.log('%c layers.comp :: sub %c find JOBS and FOLDER', this.debugPrimary, this.debugSecondary);
                }
                // pull down any jobs that are against the current scene, but not archived
                this.fourD.V.searchByObject(_4d_mapper_1.Job)
                    .equals('scene', scene.id)
                    .equals('active', true)
                    .limit(100011)
                    .queryObservable()
                    .subscribe((value) => {
                    if (this.debug) {
                        console.log('%c layers.comp :: sub %c currentSceneJobs', this.debugPrimary, this.debugSecondary, value.items);
                    }
                    if (value.items) {
                        this.currentSceneJobs = value.items;
                    }
                    else {
                        this.currentSceneJobs = [];
                    }
                    // update all additional file info
                    this.updateAdditionalFiles();
                });
            }
            // pull in the cesiumHelper
            // this.cesiumHelper = this.mapService.helper;
            /*
    
            // Get list of items to plot for this group
            var toPlot = [];
            if (this.mapService.sceneTransforms) {
              toPlot = this.mapService.sceneTransforms.filter(p =>
                (this.mapService.scene['layerProps'][MapService.TOGGLE + p.id])
              )
            }
    
            // if exsiting plots are up, identify items to remove
            // dont conut anything thats to be added with new scene
            var toNuke = this.plottedItems.filter(p =>
              !toPlot.find(s => p.id == s.id)
            )
    
            if ( this.debug ) { console.log ( '%c layers.comp :: sub %c nukeItems', this.debugPrimary, this.debugSecondary, toNuke ); }
    
            // remove old items
            toNuke.forEach(p => {
              if (p['ds_type_uid'] !== 'zkml') {
                this.cesiumHelper.removePlottable(p)
              } else {
                const kml = this.kmlDataSource.find(kmlD => kmlD.id === p.id);
                if (kml) {
                  kml['dataSource']['show'] = false;
                }
              }
    
              // let plugins = this.pluginManager.getByItem(p);
              // this.clearPlugins(plugins);
    
             //  console.log ( '$$$$$$$$$$$$$$$$$$$$$$$$$$$$ should DESTROY these', plugins);
            });
    
            // get a list of remaining items
            this.plottedItems = this.plottedItems.filter(p => !toNuke.find(n => n == p));
    
            this.loading = false;
            Constants.hideHangOn();
    */
            // moved stuff from here to the events above
            // if ( this.debug ) { console.log ( '%c layers.comp :: sub %c combiner', this.debugPrimary, this.debugSecondary, toPlot ); }
            // Only plot the items not already plotted
            /* combineLatest(
              toPlot.filter(p =>
                !this.plottedItems.find(s => s.id == p.id)
              ).map(p => {
                return this.cesiumHelper.setPlottable(p).pipe(tap( e => {
    
                  if ( this.debug ) { console.log ( '%c layers.comp :: sub %c combineLatest p checkTransform', this.debugPrimary, this.debugSecondary, p.id ); }
    */
            /* this.featureDetector.checkTransform(p).then( meta => {
    
                    if ( this.debug ) { console.log ( '%c layers.comp :: sub %c combineLatest checkTransform THEN', this.debugPrimary, this.debugSecondary, p.id, meta ); }
    
                    // update any additional features of the item (contrast, wireframe, opacity, etc.)
                    this.updateItem(p, this._saveSubj);
    
                    // load in any plugins for the transforms (if saved to them)
                    if ( this.debug ) { console.log ( '%c layers.comp :: sub %c combiner FINDING PLUGINS FOR TRANSFORM', this.debugPrimary, this.debugSecondary, p.id, meta ); }
                    this.transformPlugins.loadFrom( p, this.mapService.scene.id );
    
                  }); */
            /*
                }));
              })
            ).pipe(
              take(1),
            ).subscribe(
              incoming => {
    
                this.loading = false;
    
                if ( this.debug ) { console.log ( '%c layers.comp :: sub %c ================', this.debugPrimary, this.debugSecondary, toPlot, incoming ); }
                Constants.hideHangOn();
                this.mapService.reorderTransform();
                if (this.mapService.flyToFirstTransform) {
                  if ( this.debug ) { console.log ( '%c layers.comp :: sub %c combine flyTo', this.debugPrimary, this.debugSecondary ); }
                  this.flyTo(toPlot[0]);
                }
    
                /
                // check all layers for various states, issues and trouble, and then do something with them when we're ready for plugins and updates ...
                this.checkLayers().then( _ => {
    
                  // go through all our plotted items
                  this.plottedItems.forEach ( item => {
    
                    // update any additional features of the item (contrast, wireframe, opacity, etc.)
                    this.updateItem(item, this._saveSubj);
    
                    // load in any plugins for the transforms (if saved to them)
                    if ( this.debug ) { console.log ( '%c layers.comp :: sub %c combiner FINDING PLUGINS FOR TRANSFORM', this.debugPrimary, this.debugSecondary, item ); }
                    this.transformPlugins.loadFrom( item, this.mapService.scene.id );
                    
                  });
                });
                /
    
              },
              e => this.openSnackBarError(e.message)
            )
            if (this.mapService.sceneTransforms) {
              this.hasShapes = !!this.mapService.sceneTransforms.find(s => s['ds_type_uid'] == 'shape-zip')
            }
    
            this.plottedItems = toPlot
            */
        }));
        // I think this one can be killed off?
        this.addSubscription('waitForTerrain', this.mapService.onTerranCompareStarted().subscribe((jobId) => {
            this.waitForTerrainCompareResult(jobId);
        }));
        /* disabled, possibly remove
        // access control changes
        this.permissions.updatedAccess$.subscribe(tmp => {
          if ( this.debug ) { console.log ( 'main subscribed event access control' );}
          this.permissionsChanged();
        });
        */
    }
    destroy() {
        if (!this.removeTransformPlugins && this.transformPlugins) {
            this.transformPlugins.removeAll();
            delete this.transformPlugins;
        }
        if (this.sceneBuckets) {
            this.sceneBuckets.removeAll();
            delete this.sceneBuckets;
        }
        if (this.currentSceneGuid) {
            this.pluginManager.unregisterGuid(this.currentSceneGuid); // this also deletes any plugins attached
        }
        if (this.metaScene) {
            this.pluginManager.unregisterGuid(this.metaScene); // this also deletes any plugins attached
            this.metaScene = null;
        }
        this.splitViewer.stop();
        this.tileProfiler.stop();
        if (this.debug) {
            console.log('%c layers.comp %c destroy()', this.debugPrimary, this.debugSecondary);
        }
    }
    toggleAll(what = 'layers', state = true) {
        this.mapService.sceneTransforms.forEach((p) => {
            let type = 'layers';
            if (p['isTerrain']) {
                type = 'terrains';
            }
            if (type == what) {
                let s = this.mapService.scene['layerProps'][map_service_1.MapService.TOGGLE + p.id];
                if (s !== state) {
                    //console.log('t **', p.name, state, s);
                    this.toggle(p);
                }
                else {
                    //console.log('t', p.name, state, s);
                }
            }
        });
    }
    unselectTerrainModels() {
        this.toggleAll('terrains', false);
        this.sceneSelectedTerrainModel = null;
    }
    selectTerrainModel(item) {
        this.unselectTerrainModels();
        setTimeout(() => {
            this.toggle(item);
            this.sceneSelectedTerrainModel = item;
        }, 100);
    }
    transformsOrderAndGroup() {
        this.regroupTransforms();
        this.mapService.reorderTransform();
        this.mapService.saveSceneTransformsOrders();
    }
    // some light categorisation of types
    addTransformTypes(p) {
        let type = p['type_uid'];
        let ds_type = p['ds_type_uid'];
        if (!this.sceneTransformsByType.types) {
            this.sceneTransformsByType.types = {};
        }
        if (!this.sceneTransformsByType.ds_types) {
            this.sceneTransformsByType.ds_types = {};
        }
        if (!this.sceneTransformsByType.types[type]) {
            this.sceneTransformsByType.types[type] = [];
        }
        this.sceneTransformsByType.types[type].push(p.id);
        if (!this.sceneTransformsByType.ds_types[ds_type]) {
            this.sceneTransformsByType.ds_types[ds_type] = [];
        }
        this.sceneTransformsByType.ds_types[ds_type].push(p.id);
    }
    // some light categorisation of kinds of Transforms
    addTransformCategories(p) {
        let data = p.id;
        let myType = p['fdm_features']['isTerrain'] ? 'terrain' : null;
        if (!myType) {
            myType = p['fdm_features']['isPhoto'] ? 'photo' : null;
        }
        if (!myType) {
            myType = p['fdm_features']['isRaster'] ? 'raster' : null;
        }
        if (!myType) {
            myType = p['fdm_features']['isVector'] ? 'vector' : null;
        }
        if (!myType) {
            myType = p['fdm_features']['isTileset'] ? 'tileset' : null;
        }
        if (!myType) {
            myType = 'unknown';
            data = p['fdm_features'];
        }
        if (!this.sceneTransformsByCategory[myType]) {
            this.sceneTransformsByCategory[myType] = [];
        }
        this.sceneTransformsByCategory[myType].push(data);
    }
    regroupTransforms() {
        // console.log ( '%c layers.comp %c regroupTransforms()', this.debugPrimary, this.debugSecondary );
        this.sceneTransforms = [];
        this.sceneTransformsActive = [];
        this.sceneTerrainModels = [];
        this.sceneSelectedTerrainModel = null;
        this.sceneFirstTransformNotTerrainModel = null;
        this.sceneTransformsById = {};
        this.sceneTransformsByType = {};
        this.sceneTransformsByCategory = {};
        // go through all Transforms
        this.mapService.sceneTransforms.forEach((p) => {
            this.checkAndConfigureFeatures(p);
            this.sceneTransformsById[p.id] = p;
            this.addTransformTypes(p);
            this.addTransformCategories(p);
            p['isTerrain'] = false;
            if (p['fdm_features'] && p['fdm_features']['isTerrain']) {
                if (!this.sceneSelectedTerrainModel) {
                    if (this.mapService.scene['layerProps'][map_service_1.MapService.TOGGLE + p.id]) {
                        this.sceneSelectedTerrainModel = p;
                    }
                }
                p['isTerrain'] = true;
                this.sceneTerrainModels.push(p);
            }
            else {
                if (!this.sceneFirstTransformNotTerrainModel) {
                    this.sceneFirstTransformNotTerrainModel = p;
                }
                this.sceneTransforms.push(p);
                if (this.mapService.scene['layerProps'][map_service_1.MapService.TOGGLE + p.id]) {
                    this.sceneTransformsActive.push(p);
                }
                if (!this.sceneTransformsActiveViews[p.id]) {
                    this.sceneTransformsActiveViews[p.id] = true;
                }
            }
            // this.sceneTransformsActive = this.sceneTransforms.filter ( t => this.mapService.scene['layerProps'][MapService.TOGGLE + t.id] );
        });
    }
    _visualizer_label(v) {
        return v.constructor.name;
    }
    _visualizer(v) {
        let t = v.constructor.name;
        let ret = [];
        /*
        Object.keys(v).forEach ( key => {
          Object.keys(v[key]).forEach ( k => {
            ret.push(key+' : '+k);
          });
        });
        return ret;
        */
        switch (t) {
            case 'ModelVisualizer':
                if (v._modelHash) {
                    Object.keys(v._modelHash).forEach((key) => {
                        ret.push(key);
                    });
                }
                break;
            case 'Cesium3DTilesetVisualizer':
                if (v._tilesetHash) {
                    Object.keys(v._tilesetHash).forEach((key) => {
                        ret.push(key);
                    });
                }
                break;
            case 'PointVisualizer':
            case 'BillboardVisualizer':
            case 'LabelVisualizer':
            default:
                if (v._items && v._items._hash) {
                    Object.keys(v._items._hash).forEach((key) => {
                        ret.push(key);
                    });
                }
                else if (v._items) {
                    Object.keys(v._items).forEach((key) => {
                        ret.push(key);
                    });
                }
                break;
        }
        return ret;
    }
    isReady(t) {
        if (!this.mapService || !this.mapService.helper) {
            return false;
        }
        let obj = this.mapService.helper.getMapObjectFor(t);
        if (obj && obj.object) {
            let ready = obj.object.ready;
            const type = obj.object.constructor.name;
            if (type == 'ImageryLayer' || (t.transformType && t.transformType.name == 'TMS')) {
                let p = obj.object._imageryProvider;
                if (p) {
                    // && p.hasOwnProperty('ready')
                    return p.ready ? 'check-square' : 'fan';
                }
                else {
                    return 'bug';
                }
            }
            return ready ? 'check' : 'spinner';
        }
        return null;
    }
    isEntityType(t) {
        let obj = this.mapService.helper.getMapObjectFor(t);
        if (this.cc-- < 0) {
            this.cc = 1000;
            console.log('###entity', t, obj, this.mapService.scene);
        }
        if (obj && obj.object) {
            return obj.object.constructor.name;
        }
        return 'unknown';
    }
    isLoading(item) {
        const t = this.getCesiumObject(item);
        if (t && t.hasOwnProperty('isLoading')) {
            // console.log('$$$$$$$$$$$$$')
            return t['isLoading'];
        }
        return false;
    }
    /*
    checkLayers() {
  
      // console.log ( '@@@@@@@@ CHECK ALL LAYERS', this.plottedItems );
  
      return new Promise ( (resolve,reject) => {
  
        let terrains = this.plottedItems.filter( t => t['isTerrain'] );
        let other = this.plottedItems.filter( t => !t['isTerrain'] );
  
        console.log ( '@@@@@@@@ I PROMISE to check ALL Transforms', terrains.length, other.length );
  
        let terrainsCount = 0;
        let otherCount = 0;
  
        // always do terrains first
        terrains.forEach ( t => {
          this.featureDetector.checkTransform(t).then( _ => {
            terrainsCount++;
            if ( terrains.length == terrainsCount && other.length == otherCount ) {
              console.log ( '@@@@@@@@ kept ALL my PROMISES (terrains)', terrains.length, other.length );
              resolve(null);
            }
          });
        });
  
        // ... then everything else
        other.forEach ( t => {
          this.featureDetector.checkTransform(t).then( _ => {
            otherCount++;
            if ( terrains.length == terrainsCount && other.length == otherCount ) {
              console.log ( '@@@@@@@@ kept ALL my PROMISES (other)', terrains.length, other.length );
              resolve(null);
            }
          });
        });
  
      });
  
    }
  */
    // checkLayer ( t:Transform = null ) {
    // this.featureDetector.checkTransform(t);
    // let me = this;
    // setTimeout ( () => { me.featureDetector.checkTransform(t); }, 1000 );
    /*
      let obj = this.mapService.helper.getMapObjectFor(t);
  
      if ( obj.boundingSphere ) {
  
        let center = obj.boundingSphere.center;
        let radius = obj.boundingSphere.radius;
        let length = radius/2;
  */
    /* this.mapService.viewer.entities.add({
          position: center,
          ellipsoid: {
              radii: new Cesium.Cartesian3 ( radius, radius, radius ),
              material: Cesium.Color.WHITE.withAlpha(0.0001),
              outline: true,
              outlineColor: Cesium.Color.YELLOW.withAlpha(0.4),
              slicePartitions: 10,
              stackPartitions: 15,
          }
      })
  
      this.mapService.viewer.entities.add({
        position: center,
        ellipse: {
          semiMinorAxis: radius,
          semiMajorAxis: radius,
          material: Cesium.Color.RED.withAlpha(0.1),
        }
    }) */
    /*
        let p  = this.featureDetector.___sampleHeight ( 'p', center );
        let p1 = this.featureDetector.___sampleHeight ( 'p1', this.featureDetector.worldToCartesian( p.cartographic ), { offsetLongitude: length, offsetLatitude: length } );
        let p2 = this.featureDetector.___sampleHeight ( 'p2', this.featureDetector.worldToCartesian( p.cartographic ), { offsetLongitude: -length, offsetLatitude: -length } );
  
        let positions = [ p1.cartesian, p.cartesian, p2.cartesian ];
  
        
        let test = this.profileAnalysis ( p1.cartesian, p2.cartesian );
  
        test.then ( results => {
          console.log ( '%c LAYERS %c checkLayer() RESULTS', this.debugPrimary, Constants._red, results );
          me.mapService.viewer.entities.add({
            polyline: {
                positions: results.samplingPoints,
                width: 4.0,
                material: Cesium.Color.YELLOW.withAlpha(0.5)
            }
          });
          me.mapService.viewer.entities.add({
            polyline: {
                positions: results.renderPoints,
                width: 4.0,
                material: Cesium.Color.RED,
            }
          });
        });
  
        
        console.log ( '%c LAYERS %c checkLayer()', this.debugPrimary, Constants._red, length, p, p1, p2, positions, test );
  
  */
    // }
    /*
  
      return;
  
      // is there an issues log? No? create it
      if ( !t.hasOwnProperty('issues') ) {
        t['issues'] = {};
      }
  
      let issues = t['issues'];
  
      if ( !issues.hasOwnProperty('heightOffset') || ! issues.heightOffset['isChecked'] ) {
        issues['heightOffset'] = {
          icon: 'exclamation-circle',
          isChecked: false,
          isOver: false,
          isDismissed: false,
          isShown: false,
          tooltipToken: null,
          entityCoord: null,
          entityCoordCartographic: null,
          terrainCoord: null,
          terrainCoordCartographic: null,
          entityHeight: null,
          entityHeightPicked: null,
          terrainHeight: null,
          offsetHeight: null,
          fromEntity: null,
          lineEntity: null,
          toEntity: null,
          obj: null
        };
      }
  
      let issue = issues.heightOffset;
  
      if ( issue.isDismissed ) {
        return;
      }
  
      // let me = this;
      let obj = this.mapService.helper.getMapObjectFor(t);
      let plugin = this.pluginManager.findPlugin('perimeter','scene');
  
      // console.log ( '%c **************** T CHECKING ... ['+t.name+']', Constants._purple, issue, obj, plugin );
  
      if ( obj.object.imageryProvider ) {
  
        obj.object.getViewableRectangle().then(function (rectangle) {
  
          let sub = Cesium.Rectangle.subsample(rectangle, Cesium.Ellipsoid.WGS84, 20.0 );
  
          
          if ( plugin ) {
            plugin.add ( t, obj, sub );
          }
  
          // sub.push ( sub[0] );
          // console.log ( '%c **************** T IMAGE RESULT ['+t.id+']', Constants._purple, rectangle, sub );
  *
          this.selectedEntityRendered = me.mapService.viewer.entities.add({
            polyline: {
              positions: sub,
              width: 3.0,
              material: new Cesium.PolylineDashMaterialProperty({
                color: Cesium.Color.ORANGE.withAlpha(0.8)
              }),
              depthFailMaterial: new Cesium.PolylineDashMaterialProperty({
                color: Cesium.Color.ORANGE.withAlpha(0.3)
              }),
            }
          });
          *
          // setTimeout( ()=>{ me.mapService.viewer.entities.remove (me.selectedEntityRendered); me.selectedEntityRendered=null; }, 4000 );
    
      });
    }
  
      if ( obj && obj.boundingSphere ) {
  
        if ( plugin ) {
          // passing in null means it will try to find the positions by traversing the tileset
          plugin.add ( t, obj, null );
        }
  
        issue.obj = obj.object;
  
        issue.entityCoord = obj.boundingSphere.center;
  
  
  
  
  
        issue.entityCoordCartographic = new Cesium.Cartographic.fromCartesian( issue.entityCoord );
        issue.entityHeight = issue.entityCoordCartographic.height;
  
        var position=[issue.entityCoordCartographic];
        
        var promise = Cesium.sampleTerrain(this.mapService.viewer.terrainProvider, 11, position);
  
        // console.log ( '%c **************** T PROMISING ... ['+t.name+']', Constants._purple, issue, obj, me.mapService.viewer );
  
        Cesium.when(promise, function(updatedPosition) {
  
          issue.terrainHeight = updatedPosition[0].height ? updatedPosition[0].height : 0;
          issue.offsetHeight = Math.abs ( Math.round( issue.terrainHeight - issue.entityHeight ) );
          issue.isChecked = true;
  
          issue.terrainCoordCartographic = updatedPosition[0];
          issue.terrainCoordCartographic.height = issue.terrainHeight;
  
          issue.terrainCoord = new Cesium.Cartographic.toCartesian( issue.terrainCoordCartographic );
          // const positiongeo = Cesium.Cartesian3.fromRadians(issue.entityCoordCartographic.longitude, issue.entityCoordCartographic.latitude, 0);
          const ray = new Cesium.Ray( issue.entityCoord, issue.terrainCoord );
          const screen = Cesium.SceneTransforms.wgs84ToWindowCoordinates(me.mapService.viewer.scene, issue.terrainCoord );
  
          
          let p1 = null, p2 = null, p3 = null, p4 = null, p5 = null, p6 = null;
          let picks = [];
          let ex = [];
  
          try {
  
            if ( screen ) {
  
              p1 = me.pickRay ( screen );
              picks.push( p1 );
  
              p4 = me.mapService.viewer.camera.pickEllipsoid(screen);
              picks.push( p4 );
  
              p5 = me.mapService.viewer.scene.pickPosition(screen);
              picks.push( p5 );
  
              p6 = me.measureHelper.pickPositionSnapToTileset(screen);
              picks.push( p6 );
  
            }
            
            p2 = me.mapService.viewer.scene.globe.pick(ray, me.mapService.viewer.scene);
            picks.push( p2 );
  
            p3 = me.mapService.viewer.scene.pickFromRay(ray, ex );
            picks.push( p3 );
  
            
          } catch (error) {
            console.error ( error );
          }
  
          let c = 0;
          let colors = [ Cesium.Color.BLUE.withAlpha(0.8), Cesium.Color.GOLD.withAlpha(0.8), Cesium.Color.GREEN.withAlpha(0.8), Cesium.Color.LIME.withAlpha(0.8), Cesium.Color.YELLOW.withAlpha(0.8) ];
          picks.forEach ( p => {
            
            if ( false && p ) {
              me.mapService.viewer.entities.add ({
                position: p,
                point: {
                    pixelSize: 20,
                    color: colors[c],
                },
                label: {
                  text: 'p'+c,
                  font : '12px sans-serif',
                  showBackground:true,
                  fillColor: Cesium.Color.WHITE,
                  backgroundColor: Cesium.Color.BLACK,
                  verticalOrigin: Cesium.VerticalOrigin.TOP,
                  eyeOffset: new Cesium.Cartesian3(0, 35, -4)
              },
              });
            }
            
            c = c + 1;
  
          });
  
          // console.log ( '%c **************** T RESULT ['+t.id+']', Constants._purple, issue.entityCoord, issue.terrainCoord, screen, ray, issue );
          // console.log ( '%c **************** T PICK ['+t.id+']', Constants._purple, picks );
          
  
          // let pick = pick1 ? pick1 : pick2;
  
          // let find = this.mapService.viewer.scene.pickFromRay ( ray, ex );
  
          // console.log ( '%c **************** T PICK DRILL ['+t.id+']', Constants._purple, find );
  
          // var p = this.mapService.viewer.scene.pickPositionFromRay(ray);
  
          // let picks = me.pickRay ( issue.entityCoord, cart );
  *
          me.mapService.viewer.entities.add ({
            position: positiongeo,
            point: {
                pixelSize: 20,
                color: Cesium.Color.WHITE.withAlpha(0.8),
            }
          });
  /
          
          
  
          // console.log ( '%c **************** T PICK ['+t.id+']', Constants._purple, res );
  
          // let ph = new Cesium.Cartographic.fromCartesian( p );
          // issue.entityHeightPicked = ph['height'];
  
  
  
  
          if ( issue.offsetHeight > 30 ) {
            issue.isOver = true;
  
            * issue.lineEntity = me.mapService.viewer.entities.add ({
              name: 'bounding : area : polyline',
              polyline: {
                  positions: [ issue.entityCoord, issue.terrainCoord ],
                  width:4,
                  material: Cesium.Color.YELLOW.withAlpha(0.8),
              }
            });
  
            issue.fromEntity = me.mapService.viewer.entities.add ({
              position: issue.entityCoord,
              point: {
                  pixelSize: 20,
                  color: Cesium.Color.RED.withAlpha(0.8),
              }
            });
  
            issue.toEntity = me.mapService.viewer.entities.add ({
              position: issue.terrainCoord,
              point: {
                  pixelSize: 20,
                  color: Cesium.Color.YELLOW.withAlpha(0.8),
              }
            }); /
  
          }
  
          issue.obj = null;
  
        });
  
      } else {
        issue.isDismissed = true;
      }
      */
    // }
    /*
  
        let type = t.transformType.uid;
        let obj = null;
  
        if ( true || type == 'three-d-tiles' ) {
  
          obj = this.mapService.helper.getMapObjectFor(t);
  
          // console.log ( '%c **************** T OBJ ['+t.id+']', Constants._purple, obj, type, t );
    
          if ( obj && obj.boundingSphere ) {
  
          
            var tileCentre = new Cesium.Cartographic.fromCartesian( obj.boundingSphere.center );
            var position=[tileCentre];
            var initialTileCenterHeight = tileCentre.height;
            var promise = Cesium.sampleTerrain(this.mapService.viewer.terrainProvider, 11, position);
            // console.log ( '%c **************** T PROMISE ['+t.id+']', Constants._purple, obj, tileCentre, this.mapService.viewer.terrainProvider, promise );
    
            Cesium.when(promise, function(updatedPosition) {
  
              let newHeight = updatedPosition[0].height ? updatedPosition[0].height : 0;
    
              var heightOffset = Math.abs ( Math.round( newHeight - initialTileCenterHeight ) );
    
              console.log ( '%c **************** T RESULT ['+t.id+']', Constants._purple, updatedPosition, newHeight, heightOffset );
    
              // if ( this.debug ) { console.log ( 'checkLayers() height=['+heightOffset+']', type, t, obj); }
              if ( heightOffset > 30 ) {
                t['issues']['heightOffset'] = heightOffset;
              } else {
                t['issues']['heightOffset'] = false;
              }
    
              // t['issues']['heightOffset'] = heightOffset;
    
            });
  
          } else {
            // console.log ( '%c **************** T ERROR ['+t.id+']', Constants._purple, obj );
          }
                
  
        } else {
          // console.log ( 'checkLayers()', type, t, obj);
        }
  
      });
    }
  */
    // incoming Transform object
    checkAndConfigureFeatures(t) {
        if (!t['__issues']) {
            t['__issues'] = {};
        }
        let ttype = t['type_uid'];
        let dtype = t['ds_type_uid'];
        let features = {
            _: ttype,
            __: dtype,
            ___: t['ds_name'],
            transformId: t.id,
            transformType: ttype,
            entity: null,
            entityId: null,
            entityType: null,
            object: null,
            isClickable: false,
            isPointCloud: false,
            isTerrain: false,
            isTileset: false,
            isPhoto: false,
            isRaster: false,
            isVector: false,
            isModel: false,
            hasProperties: false,
            hasTileProperties: false,
            hasHeight: false,
            minHeight: null,
            maxHeight: null,
            canAlpha: true,
            canColorize: false,
            canHeightAdjust: false,
        };
        if (dtype == 'e57' || dtype == 'pointcloud-tile' || dtype == 'laz' || dtype == 'laslaz' || ttype == 'ply' || ttype == 'e57') {
            features.isPointCloud = true;
            features.canColorize = true;
            features.isModel = true;
        }
        if (dtype == 'laslaz' || dtype == 'e57' || ttype == 'terrain-tiles') {
            features.canAlpha = false;
            features.canColorize = true;
        }
        if (ttype == 'terrain-tiles') {
            features.isTerrain = true;
            features.canAlpha = false;
        }
        if (ttype == 'geo-json' || ttype == 'kml') {
            features.canAlpha = false;
            features.isVector = true;
        }
        if (ttype == 'three-d-tiles') {
            features.canHeightAdjust = true;
            features.isModel = true;
            features.isTileset = true;
            features.canColorize = true;
        }
        if (ttype == 'tms') {
            features.isRaster = true;
        }
        let e = this.mapService.helper.getCesiumObjectFor(t);
        // console.log('** _features **',features,e,this.cesiumHelper.getMapObjectFor(t));
        if (e) {
            features.entityId = e.id;
            features.entityType = e.constructor.name;
            if (features.entityType == 'ImageryLayer' || (t.transformType && t.transformType.name == 'TMS')) {
                features.isClickable = false;
                features.isRaster = true;
            }
            else if (features.entityType == 'Cesium3DTileset') {
                features.isClickable = true;
                features.isTileset = true;
                if (!t['__issues']['no_height']) {
                    if (!t.lheight || t.lheight < -300) {
                        t['__issues']['no_height'] = {
                            type: 'height_is_null',
                            tid: t.id,
                            ttype: ttype,
                            dtype: dtype,
                            did: t.input.id,
                            icon: 'long-arrow-alt-up',
                            isDismissed: false,
                            isShown: true,
                            label: 'No height',
                            description: 'The tileset is missing a height attribute (possibly a processing error or error in the uploaded file), and might not show correctly or in the position you expected it.',
                            reportIcon: true,
                            dismissIcon: true,
                        };
                    }
                }
                /* if ( checkedPosition.tileset._content && checkedPosition.tileset._content['featuresLength'] && checkedPosition.tileset._content.featuresLength > 0 ) {
        
                  // console.log ( "@@@@ a", checkedPosition.tileset.getPropertyNames() );
          
                  checkedPosition.tileset.getPropertyNames().forEach(name => {
                    let p = checkedPosition.tileset.getProperty(name);
                    if ( p && (p +'').trim() !== '' ) {
                      this.props[name] = (p +'').trim();
                    }
                  });
                } */
                if (e._properties) {
                    features.hasProperties = true;
                    if (e._properties.Height) {
                        features.hasHeight = true;
                        if (e._properties.Height.maximum) {
                            features.maxHeight = e._properties.Height.maximum;
                        }
                        if (e._properties.Height.minimum) {
                            features.minHeight = e._properties.Height.minimum;
                        }
                    }
                }
                if (e.pointCloudShading) {
                    features.isPointCloud = true;
                }
            }
            else {
            }
            // if ( )
        }
        t['fdm_features'] = features;
        // if ( this.debug ) {  console.log ( '%c layers.comp %c checkAndConfigureFeatures('+t.id+') FOUND FEATURES', this.debugPrimary, this.debugSecondary, features, t, e); }
    }
    dismissIssue(issue) {
        // if ( !issue.isDismissed ) {
        issue.isDismissed = true;
        // }
    }
    clickReportIssue(issue = null) {
        this.contactUsRequest = {
            subject: '',
            priority: 'normal',
            category: 'question',
            body: '',
            issue: issue,
        };
        this.contactUsShow = true;
    }
    clickReportIssueSend() {
        this.contactUsState = 'sending';
        const lf = '\n';
        let extra = '';
        if (this.contactUsRequest.issue) {
            if (this.contactUsRequest.issue.type) {
                extra = extra + 'Type=' + this.contactUsRequest.issue.type + `${lf}`;
            }
            if (this.contactUsRequest.issue.tid) {
                extra = extra + 'TransformID=' + this.contactUsRequest.issue.tid + `${lf}`;
            }
            if (this.contactUsRequest.issue.ttype) {
                extra = extra + 'TransformType=' + this.contactUsRequest.issue.ttype + `${lf}`;
            }
            if (this.contactUsRequest.issue.did) {
                extra = extra + 'DatasetID=' + this.contactUsRequest.issue.did + `${lf}`;
            }
            if (this.contactUsRequest.issue.dtype) {
                extra = extra + 'DatasetType=' + this.contactUsRequest.issue.dtype + `${lf}`;
            }
        }
        this.contactUsRequest.body = `${lf}${this.contactUsMessage} ${lf}` + extra;
        // console.log('!! email OK', this.contactUsRequest );
        // return;
        // send support tickets through ZenDesk
        this.service.sendSupportTicket(this.contactUsRequest).subscribe((res) => {
            this.contactUsState = 'sent';
            //console.log('!! email OK', request, res );
        }, (e) => {
            this.contactUsState = 'error';
            //console.log('!! email ERROR', request, e );
        });
    }
    clickReportIssueDone() {
        this.contactUsShow = false;
        this.contactUsState = 'ready';
    }
    // when the tab (map.component) is setting this component as active
    becameActive(mapComp = null) {
        // this.debug = true;
        // new, refactored code
        this.mapService.scene.fetchObservable().subscribe((_) => {
            this.incomingData.populateFromScene(this.mapService.scene);
        });
        // (@alex) I don't think any of this is necessary; evaluating if we should kill it (with fire); old Haresh code, replaced by the above
        // note : even if there's a current scene, the "folder" sub-property might take a bit to populate, so that's why
        //        the below code is a bit, hmmm, odd
        if (this.mapService.scene) {
            // get list of datasets which user can tile from layers.
            if (this.mapService.scene.folder) {
                if (this.debug) {
                    console.log('%c layers.comp %c becameActive() FOLDER', this.debugPrimary, this.debugSecondary);
                }
                this.mapComponent.fetchDatasetForManualTiling(this.mapService.scene.folder);
            }
            else {
                if (this.debug) {
                    console.log('%c layers.comp %c becameActive() NO FOLDER', this.debugPrimary, this.debugSecondary);
                }
                this.mapService.scene.fetchObservable().subscribe((_) => {
                    // TODO : there's a bug here where scene can be null, but I don't know exactly what this code is trying to do (@haresh)
                    if (this.mapService.scene.folder) {
                        if (this.debug) {
                            console.log('%c layers.comp %c becameActive()NOW FOUND FOLDER', this.debugPrimary, this.debugSecondary);
                        }
                        this.mapComponent.fetchDatasetForManualTiling(this.mapService.scene.folder);
                    }
                    else {
                        if (this.debug) {
                            console.log('%c layers.comp %c becameActive()STILL NO FOLDER', this.debugPrimary, this.debugSecondary);
                        }
                    }
                });
            }
        }
        else {
            if (this.debug) {
                console.log('%c layers.comp %c becameActive() NO_SCENE', this.debugPrimary, this.debugSecondary);
            }
        }
        // this.debug = false;
    }
    // when the tab (map.component) is setting this component as inactive
    becameInactive(mapComp) {
        if (this.debug) {
            console.log('%c layers.comp %c becameInactive()', this.debugPrimary, this.debugSecondary);
        }
    }
    debugTileset(t) {
        // fetch the transformation ID
        let transformId = t._tileset.transform_id;
        // see if we can find it in our list of transformations
        let transformFind = this.sceneController.plottedTransforms.filter((t) => t.id == transformId);
        let transform = transformFind[0] ? transformFind[0] : null;
        console.error('!!!! tId, t', transformId, transformFind, transform);
        console.error('!!!! ti, t, tile, tileset', t, t._tile, t._tileset);
    }
    //  setSceneCameraView() {
    //    if (this.mapService.scene) {
    //      this.mapService.scene['cameraPosition'] = this.sceneController.getCamera();
    //      this.mapService.scene.saveObservable().subscribe( _ => { console.log('@@saved_scene',this.mapService.scene)});
    //    }
    //  }
    // setSceneAsDefault() {
    //  if (this.mapService.scene) {
    //    this.mapService.currentProject['lastActiveScene'] = this.mapService.scene.id;
    //    this.mapService.currentProject.saveObservable().subscribe();
    //  }
    // }
    // incoming clicks (when this layers component is active)
    clickedMap(movement, rightClick, checkedPosition) {
        if (this.debug) {
            console.log('%c layers.comp %c clickedMap()', this.debugPrimary, this.debugSecondary, checkedPosition, this.measureHelper.pickedModel);
        }
        const feature = this.measureHelper.pickedModel;
        // var features = this.mapService.viewer.scene.drillPick(movement.position, 2, 10, 10);
        // var feature = this.mapService.viewer.scene.pick(movement.position, 10, 10);
        this.featureProperties = {};
        if (feature instanceof Cesium.Cesium3DTileFeature) {
            var propertyNames = feature.getPropertyNames();
            var length = propertyNames.length;
            for (var i = 0; i < length; i++) {
                var propertyName = propertyNames[i];
                this.featureProperties[propertyName] = feature.getProperty(propertyName);
            }
        }
        /*
        this.isFeatureDescription = false;
        if (feature && feature.id && feature.id.properties) {
          this.featureProperties = feature.id.properties.getValue();
        } else if (feature && feature.id && feature.id.description) {
          description will be html content
          this.isFeatureDescription = true;
          this.featureProperties = feature.id.description._value;
        }
    */
        if (!Constants_1.Constants.isEmpty(this.featureProperties)) {
            this.router.navigate(['featureProperties'], {
                state: { movement: movement },
                relativeTo: this.route,
            });
        }
        if (this.hasShapes && this.mapService.isAgronomeye && Constants_1.Constants.isEmpty(this.featureProperties)) {
            var i = -1;
            // disabled GeoJSON component
            // var s = this.mapService.sceneTransforms.find(s => s['ds_type_uid'] == 'shape-zip')
            // this.router.navigate(['/app/projects/map',this.mapService.currentProject.id,'geojson',s.id,i])
            if (rightClick)
                this.router.navigate([this.fourD.activeUser ? '/app/projects/map' : '/map', this.mapService.currentProject.id, 'layers']);
            else {
                this.router.navigate([
                    this.fourD.activeUser ? '/app/projects/map' : '/map',
                    this.mapService.currentProject.id,
                    'geojson',
                    Cesium.Math.toDegrees(this.mapComponent.currentCoord.position.latitude),
                    Cesium.Math.toDegrees(this.mapComponent.currentCoord.position.longitude),
                ]);
                return map_component_1.ClickDisplay.Chevron;
            }
        }
        else {
            if (rightClick)
                this.router.navigate([this.fourD.activeUser ? '/app/projects/map' : '/map', this.mapService.currentProject.id, 'layers']);
            return rightClick ? map_component_1.ClickDisplay.None : map_component_1.ClickDisplay.Chevron;
        }
    }
    /*
    mouseHoverClick ( inp:Transform ) {
      this.pre_selected_hover_item = inp;
      this.mouseHoverForReal ( inp );
    }
  
    // mousehover() is debouncing mousehoverforreal()
    mouseHover (  inp:Transform ) {
      // console.log('hover', inp );
      this.pre_selected_hover_item = inp;
      let me = this;
      setTimeout ( () => {
        me.mouseHoverForReal ( inp );
      }, 800 );
    }
  
    // ok, the preselected item is still there, so make it a proper hover
    mouseHoverForReal ( inp:Transform ) {
  
      if ( this.pre_selected_hover_item ) {
        this.pre_selected_hover_item = null;
        this.selected_hover_item = inp;
        let id = inp.id;
        // console.log('hover real', id, inp );
    
        if ( ! this.pluginHover[id] ) {
          this.pluginHover[id] = {
            hovering:false
          };
        }
        if ( this.pluginHover[id].hovering ) {
          return;
        }
        this.pluginHover[id].hovering = true;
        let find = document.getElementById('plugin-hover-for-'+id);
        let pop = document.getElementById('plugin-hover-popover');
        if ( find && pop ) {
          let pos = find.getBoundingClientRect();
          // let markerpos = this.marker.getBoundingClientRect();
          pop.style.top = pos.top - 8 + 'px';
          pop.style.left = pos.left - 8 + 'px';
          
        }
      }
    }
  
    // leaving the icon means kill the preselected hover to go through (mouse moved on)
    mouseLeaveIcon ( inp:Transform ) {
      this.pre_selected_hover_item = null;
    }
  
    // this leave is leaving the popover menu
    mouseLeave( inp:Transform ) {
      if ( inp ) {
        let id = inp.id;
        // console.log('leave', id, inp );
        if ( this.pluginHover[id] && this.pluginHover[id].hovering ) {
          this.pluginHover[id].hovering = false;
          let pop = document.getElementById('plugin-hover-popover');
          if ( pop ) {
            pop.style.top = '-101px';
            pop.style.left = '-101px';
          }
          // console.log('leave',inp);
        }
        this.selected_hover_item = null;
        this.pre_selected_hover_item = null;
      }
    }
  
    clickedPluginsHover ( name:string = null, inp:Transform = null, event:any = null ) {
      let me = this;
      let thisone = this.selected_hover_item;
      if ( inp ) {
        let newid = this.transformPlugins.create(name,null,inp);
        setTimeout ( () => {
          let plugin = me.pluginManager.get(newid);
          this.activatePluginPopover(plugin, thisone, event );
        }, 300 );
      }
      if ( this.selected_hover_item ) {
        this.mouseLeave ( this.selected_hover_item );
      }
    }
  
  */
    plotKML(p) {
        const kml = this.kmlDataSource.find((kmlD) => kmlD.id === p.id);
        if (kml) {
            // if kml already plotted on cesiume then dont plot it again
            kml['dataSource']['show'] = true;
            return;
        }
        this.loadingKML = true;
        var options = {
            camera: this.mapService.viewer.scene.camera,
            canvas: this.mapService.viewer.scene.canvas,
        };
        this.mapService.viewer.dataSources.add(Cesium.KmlDataSource.load(p.file('data'), options)).then((dataSource) => {
            this.kmlDataSource.push({ id: p.id, dataSource: dataSource });
            this.loadingKML = false;
        });
    }
    // Plugin management
    itemId(item) {
        return 'layer-' + item.id;
    }
    inspectItem(item) {
        // console.log ( '???', item);
        const obj = this.mapService.helper.getCesiumObjectFor(item);
        console.log('???', item, obj);
    }
    objectEntityCount(item) {
        let ret = 0;
        let p = null;
        const obj = this.mapService.helper.getCesiumObjectFor(item);
        if (obj) {
            if (obj._entities || obj.entities) {
                p = obj._entities || obj.entities;
                if (p.values) {
                    p = p.values;
                }
                if (p.length) {
                    ret = p.length;
                }
            }
        }
        if (this.checkEntities) {
            this.checkEntities = false;
            setTimeout(() => {
                this.checkEntities = true;
            }, 3000);
            // console.log('#entities',obj,p,typeof p, p?p['length']:null );
        }
        return ret;
    }
    pullEntities(entities, data = {}, stats = null, level = 1) {
        if (!stats) {
            stats = {
                total_entities: 0,
                total_collections: 0,
                total_levels: 0,
            };
        }
        stats['total_collections']++;
        if (entities && entities.length) {
            let n = 0;
            entities.forEach((pp, i) => {
                n++;
                stats['total_entities']++;
                if (level > stats['total_levels']) {
                    stats['total_levels'] = level;
                }
                let item = {
                    id: level + '_' + n,
                    entity: pp,
                    have_children: pp._children ? pp._children.length : 0,
                };
                if (data['parent']) {
                    item['parent'] = data['parent'];
                }
                this.entityTypes.forEach((et) => {
                    if (pp[et]) {
                        item[et] = pp[et];
                        if (!stats[et]) {
                            stats[et] = 0;
                        }
                        stats[et]++;
                    }
                });
                if (item.have_children) {
                    item['_children'] = this.pullEntities(pp._children, { parent: item.id }, stats, level + 1);
                }
                data['__' + item.id + '_' + item.have_children] = item;
            });
        }
        if (level == 1) {
            data['_stats'] = stats;
        }
        return data;
    }
    objectEntities(item) {
        let ret = {};
        let p = null;
        let obj = this.mapService.helper.getCesiumObjectFor(item);
        if (obj) {
            if (obj._entities || obj.entities) {
                p = obj._entities || obj.entities;
                if (obj['__hasCompiledProperties']) {
                    ret = obj['__hasCompiledProperties'];
                }
                else {
                    if (p.values) {
                        // console.log('#e',p);
                        p = p.values;
                    }
                    if (p && p.length) {
                        console.log('#e', obj, this.pullEntities(p));
                        let unique = {};
                        let tmp = { types: {}, properties: {}, children: {} }; // obj['__hasCompiledProperties'];
                        p.forEach((pp, i) => {
                            let props = pp._properties || pp.properties;
                            let type = pp['_polygon'] || pp['_polyline'] || pp['_billboard'] || pp['_point'] || pp['_label'] || null;
                            let clazz = type ? type.constructor.name : 'unknown';
                            if (clazz == 'unknown') {
                                // console.log('#e ('+clazz+')',pp._children.length,pp);
                            }
                            else {
                                // console.log('#e ('+clazz+')',pp._children.length,type);
                            }
                            if (!tmp.types[clazz]) {
                                tmp.types[clazz] = 0;
                            }
                            tmp.types[clazz]++;
                            if (pp._children) {
                                if (!tmp.children[clazz]) {
                                    tmp.children[clazz] = 0;
                                }
                                tmp.children[clazz] + pp._children.length;
                                // console.log('.',pp._children.length);
                                if (pp._children.length) {
                                    for (let n = 0; n < pp._children.length; n++) {
                                        const e = pp._children[n];
                                        const etype = e['_polygon'] || e['_polyline'] || e['_billboard'] || e['_point'] || e['_label'] || null;
                                        const eclazz = '__' + (etype ? etype.constructor.name : 'unknown');
                                        // console.log('#ee ('+eclazz+' of '+clazz+')',e);
                                        if (!tmp.children[eclazz]) {
                                            tmp.children[eclazz] = 0;
                                        }
                                        tmp.children[eclazz]++;
                                    }
                                }
                            }
                            // let idx = i.toString().padStart(3,'0');
                            // ret[idx] = {};
                            // ret[idx]['type'] = clazz;
                            // ['name','_id'].forEach( key => {
                            //   if ( pp[key] ) { ret[idx][key] = pp[key]; }
                            // });
                            // if ( props && props._propertyNames ) {
                            //   ret[idx]['hasProps'] = typeof props._propertyNames;
                            // }
                            if (props && props._propertyNames && props._propertyNames.length) {
                                props._propertyNames.forEach((prop, idx) => {
                                    const key = prop.toString();
                                    if (!tmp.properties[key]) {
                                        tmp.properties[key] = { count: 0, unique: 0 };
                                    }
                                    tmp.properties[key].count++;
                                    // let n = props._propertyNames[key];
                                    let v = props[key] ? props[key]['_value'] : null; //  ? value['_value'] : null;
                                    if (!unique[key]) {
                                        unique[key] = {};
                                    }
                                    if (!unique[key][v]) {
                                        unique[key][v] = 0;
                                    }
                                    unique[key][v]++;
                                    // unique['__'+key+'__'+idx] = { key:key, idx:idx, obj: props[key], test: props[key] ? props[key]['_value'] : null };
                                    // ret[idx]['props'] = props._propertyNames.join(' | ');
                                });
                            }
                        });
                        Object.keys(unique).forEach((key) => {
                            if (unique[key]) {
                                tmp.properties[key].unique = Object.keys(unique[key]).length;
                            }
                        });
                        obj['__hasCompiledProperties'] = tmp;
                        console.log('#entities COMPILED', tmp, unique);
                    }
                }
            }
        }
        return ret;
    }
    objectPropertyCount(item) {
        let ret = 0;
        let p = null;
        const obj = this.mapService.helper.getCesiumObjectFor(item);
        if (obj) {
            if (obj._properties || obj.properties) {
                p = obj._properties || obj.properties;
                if (typeof p == 'object') {
                    p = Object.keys(p);
                }
                if (p.length) {
                    ret = p.length;
                }
            }
        }
        if (this.checkProperties) {
            this.checkProperties = false;
            setTimeout(() => {
                this.checkProperties = true;
            }, 3000);
            // console.log('#props',obj,p,typeof p, p?p['length']:null );
        }
        return ret;
    }
    objectProperty(item) {
        let ret = {};
        const obj = this.mapService.helper.getCesiumObjectFor(item);
        if (obj) {
            if (obj._properties || obj.properties) {
                let p = obj._properties || obj.properties;
                if (typeof p == 'object') {
                    ret = Object.keys(p);
                }
                else {
                    if (p.length) {
                        p.forEach((pp) => {
                            ret[pp] = ret[pp];
                        });
                    }
                }
                if (this.checkProperties) {
                    // console.log('#props OBJ',ret );
                }
            }
        }
        return ret;
    }
    changeOpacity(item, _saveSubj, event) {
        if (this.mapService.terrainColorized) {
            this.openDialog(this.TERRAIN_COLORIZED_MESSAGE);
        }
        else {
            // this.cItem = this.getCesiumObject ( item );
            this.mapService.changeOpacity(item, _saveSubj, event);
        }
    }
    changeProperty(name, item, _saveSubj, event = null) {
        let obj = this.mapService.helper.getCesiumObjectFor(item);
        let value = event ? event.value : this.mapService.scene['layerProps'][name + '_' + item.id];
        if (obj && obj[name] && value > 0 && value <= 3) {
            obj[name] = value;
        }
    }
    changeContrast(item, _saveSubj, event = null) {
        this.changeProperty('contrast', item, _saveSubj, event);
    }
    changeHue(item, _saveSubj, event = null) {
        this.changeProperty('hue', item, _saveSubj, event);
    }
    changeGamma(item, _saveSubj, event = null) {
        this.changeProperty('gamma', item, _saveSubj, event);
    }
    changeBrightness(item, _saveSubj, event = null) {
        this.changeProperty('brightness', item, _saveSubj, event);
    }
    changeSaturation(item, _saveSubj, event = null) {
        this.changeProperty('saturation', item, _saveSubj, event);
    }
    itemClamping(item, value = false) {
        if (item) {
            item['clamping'] = value;
            this.resetTransform(item);
        }
        return false;
    }
    tilesetWireframe(item, value = false) {
        let t = this.getCesiumObject(item);
        if (t) {
            t.debugWireframe = value;
            item['wireframe'] = value;
            item.saveObservable().subscribe();
            return t.debugWireframe;
        }
        return false;
    }
    tilesetColor(item, value = null) {
        let t = this.getCesiumObject(item);
        if (t && t.style) {
            if (value) {
                // console.log ( '!!!!!!', value, t.style.color);
                // t.style.color = Cesium.Color.fromCssColorString(value);
                t.style = new Cesium.Cesium3DTileStyle({
                    color: value,
                });
                if (value == 'rgb(255,255,255)')
                    delete item['colourStyle'];
                else
                    item['colourStyle'] = value;
                item.saveObservable().subscribe();
                // console.log ( '!!!!!!', value, t.style.color);
            }
            // if (this._saveSubj)
            //   this._saveSubj.next(this.mapService.viewer.scene);
            return t.style.color;
        }
        return false;
    }
    getTilesetColor(item) {
        let t = this.getCesiumObject(item);
        if (t && t.style) {
            return t.style.color;
        }
        return false;
    }
    updateHeight(item, value) {
        if (!value) {
            value = item.vertical_offset;
        }
        // if ( this.debug ) { console.log ( 'layers.comp :: updateHeight()', value ); }
        if (!isNaN(value)) {
            // console.log ( '---', value);
            item.vertical_offset = value;
            this.updateLayerObject(item);
        }
        else {
            item.vertical_offset = 0;
        }
        item.saveObservable().subscribe();
    }
    updateLayerObject(transform) {
        let obj = this.mapService.helper.getMapObjectFor(transform);
        if (obj && obj.boundingSphere) {
            var cartographic = Cesium.Cartographic.fromCartesian(obj.boundingSphere.center);
            var surface = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, 0.0);
            var offset = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, transform.vertical_offset || 0);
            var translation = Cesium.Cartesian3.subtract(offset, surface, new Cesium.Cartesian3());
            obj.object.modelMatrix = Cesium.Matrix4.fromTranslation(translation);
            // if ( this.debug ) { console.log ( 'layers.comp :: updateLayerObject()', obj, transform, transform.vertical_offset || 0 ); }
        }
    }
    flyToLocalCoordinates(c, t) {
        try {
            return;
            /*if (c && Math.abs(c.boundingSphere.center.z) < 500000) {
              if(this.mapService.currentProject['isLocalCoordinates']){
                var viewer = this.mapService.viewer;
                //viewer = this.mapComp.map.viewer;
                var camera = viewer.camera;
                camera.constrainedAxis = Cesium.Cartesian3.UNIT_Y;
                this.cesiumHelper.addPlottable(t).subscribe(tt => {
                  console.log(tt);
                  c = this.cesiumHelper.getCesiumObjectFor(t);
                  c.readyPromise.then((tileset) => {
                    var center = new Cesium.Cartesian3(tt.boundingSphere.center.x, tt.boundingSphere.center.y);
                    console.log(tt.boundingSphere.center);
                    camera.lookAt(center, new Cesium.Cartesian3(0, 0, 200));
                    this.openSnackBarInfo('MAP.KEYBOARD_NAVIGATION_INFO', 'OK');
                  });
                });
              }else{
                this.mapService.currentProject['isLocalCoordinates'] = true;
                this.mapService.currentProject.saveObservable().subscribe(_ => {
                  location.reload();
                });
              }
              }*/
        }
        catch (e) {
            console.log(e.message);
        }
    }
    refreshGroups(mustReloadScene = false) {
        // if ( this.debug ) {
        // console.log ( '%c layers.comp %c refreshGroups() START', this.debugPrimary, this.debugSecondary );
        // }
        // reload the scene
        this.mapService.loadScene(this.mapService.scene.id, mustReloadScene).subscribe((_) => {
            this.splitViewer = this.mapComponent.splitViewer;
            this.splitViewer.updateSplitView(this.mapService.scene);
            this.tileProfiler = this.mapComponent.tileProfiler;
            this.tileProfiler.updateTransforms(this.mapService.scene);
            this.transformsOrderAndGroup();
            // console.log ( '%c layers.comp %c refreshGroups() DONE', this.debugPrimary, this.debugSecondary );
        });
    }
    flyTo(t) {
        if (this.debug) {
            console.log('layers.comp :: flyTo()');
        }
        if (!this.mapService.scene['layerProps']['toggle_' + t.id]) {
            return;
        }
        // console.log ( '!!!', t, this.measureHelper.pickedModel );
        if (this.mapService.terrainColorized) {
            this.openDialog(this.TERRAIN_COLORIZED_MESSAGE);
        }
        else {
            if (t['ds_type_uid'] !== 'zzzkml') {
                // if (t.transformType.uid === 'terrain-tiles') {
                this.mapService.helper.sendCameraTo(t);
                // SJ Feb 2020 Why are we not using SDK?
                // } else {
                //  if (this.cesiumHelper.getCesiumObjectFor(t)) {
                //    this.mapService.viewer.zoomTo(this.cesiumHelper.getCesiumObjectFor(t));
                //  }
                // }
            }
            else {
                //plot kml file using frontend code, till we are able to merge a8 to master then move plotting kml to sdk
                const kml = this.kmlDataSource.find((kmlD) => kmlD.id === t.id);
                if (kml) {
                    this.mapService.viewer.flyTo(kml['dataSource']);
                }
            }
        }
    }
    // if valid local coordinates model then fly there, otherwise show message to remove it from the project
    validateLocalModelAndFly(t) {
        let c = this.mapService.helper.getMapObjectFor(t);
        if (c && c.boundingSphere && Math.abs(c.boundingSphere.center.z) < 500000) {
            this.flyToLocalCoordinates(c, t);
        }
        else {
            this.openSnackBarInfo('MAP.PHOTOGRAM.REMOVE_LOCAL');
        }
    }
    /* enable / disable (checkbox) of layers/items */
    /*
    resetTransform ( t: Transform ) {
      this.sceneController.unplotTransform(t).then( _ => {
        this.sceneController.plotTransform(t).then( _ => {
          setTimeout ( () => {
            this.mapService.reorderTransform();
            this.updateItem(t, this._saveSubj);
          }, 400 );
        });
      });
    }
  */
    toggleView(t, toggleButNotShow = false) {
        let e = this.mapService.helper.getCesiumObjectFor(t);
        if (e) {
            this.sceneTransformsActiveViews[t.id] = !this.sceneTransformsActiveViews[t.id];
            if (!toggleButNotShow) {
                e.show = this.sceneTransformsActiveViews[t.id];
            }
            this.mapService.scene['layerProps'][map_service_1.MapService.VIEW + t.id] = this.sceneTransformsActiveViews[t.id];
        }
    }
    toggle(t) {
        if (this.mapService.terrainColorized) {
            this.openDialog(this.TERRAIN_COLORIZED_MESSAGE);
            return;
        }
        // console.log('#### LAYERS TOGGLE', t, this.mapService.scene['layerProps'][MapService.TOGGLE + t.id] );
        if (this.mapService.scene['layerProps'][map_service_1.MapService.TOGGLE + t.id]) {
            if (!this.sceneTransformsActiveViews[t.id]) {
                this.toggleView(t, true);
            }
            // this.cesiumHelper.removePlottable(t);
            this.sceneController.unplotTransform(t).then((_) => {
                // console.log('#### LAYERS TOGGLE UNPLOTTRANSFORM');
                // this.sceneController.plottedTransforms = this.sceneController.plottedTransforms.filter(p => p.id !== t.id);
                // this.mapService.reorderTransform();
                this.mapService.scene['layerProps'][map_service_1.MapService.TOGGLE + t.id] = false;
                let plugin = this.pluginManager.findPlugin('perimeter', 'scene');
                if (plugin) {
                    plugin.delete(t);
                }
                // report that this item no longer is visual (terrains report through the globe-plugin)
                this.sceneController.report(t.id, States_1.A.TRANSPARENT_ITEM, States_1.STATE.OFF);
                this.sceneController.report(t.id, States_1.A.POINTCLOUD, States_1.STATE.OFF);
                this.sceneController.report(t.id, States_1.A.TERRAIN, States_1.STATE.OFF);
                // clean up, and reset status
                this.toggleFinal(t);
            });
        }
        else {
            // this.cesiumHelper.setPlottable(t).subscribe(s => {
            this.sceneController.plotTransform(t).then((_) => {
                // console.log('#### LAYERS TOGGLE PLOTTRANSFORM');
                // this.sceneController.plottedTransforms.push(t);
                this.mapService.scene['layerProps'][map_service_1.MapService.TOGGLE + t.id] = true;
                // remind me again of what your features are?
                this.checkAndConfigureFeatures(t);
                // update (and report to the sceneController about) this item
                this.updateItem(t, this._saveSubj);
                // clean up, and reset status
                this.toggleFinal(t);
            });
        }
    }
    // we use a toggleFinal() because turning an item on uses a subscribe() when the item is plotted to the map
    toggleFinal(t) {
        this.mapService.reorderTransform();
        this.splitViewer.updateSplitView(this.mapService.scene);
        this.tileProfiler.updateTransforms(this.mapService.scene);
        // console.log('#### LAYERS TOGGLE DONE', t, this.mapService.scene['layerProps'][MapService.TOGGLE + t.id] );
        // alert the world!
        this._saveSubj.next(this.mapService.viewer.scene);
    }
    addTransformGroup() {
        var inp = { value: '' };
        // clean reference to the layer component (as later, 'this' gets reassigned)
        // const me = this;
        // console.log ( '!!!!!!!!!!!!!!!!!!!!!! 001', this, me );
        this.translate.get('DIALOG.GROUP_NAME').subscribe((v) => {
            // inp['placeholder'] = v;
            this.openDialog('DIALOG.ADD_GROUP', null, null, null, inp).subscribe((value) => {
                if (value) {
                    this.fourD.V.searchByObject(_4d_mapper_1.TransformGroup)
                        .equals('name', value)
                        .equals('project', this.mapService.currentProject)
                        .limit(100012)
                        .queryObservable()
                        .subscribe((value1) => {
                        if (value1.items.length > 0) {
                            this.openSnackBarError('DIALOG.ALREADY_EXISTS');
                        }
                        else {
                            let tg = new _4d_mapper_1.TransformGroup(this.fourD.V);
                            tg.set({
                                name: value,
                                project: this.mapService.currentProject,
                            });
                            // set default layerProps so that whenever we load scene will not get error of undefined.
                            tg['layerProps'] = {};
                            tg.saveObservable().subscribe((res) => {
                                // need to pass the newly created TransFromGroup
                                this.mapService.updateScene(res);
                                this.refreshGroups();
                                //this.editTransformGroup(tg, this.transformGroups.length - 1);
                            });
                        }
                    });
                }
            });
        });
    }
    browseTT(tg) {
        // this.debug = true;
        if (this.debug) {
            console.log('layers.comp :: browseTT()');
        }
        this.openDialogWithModeAndFilterAndMeta({
            project: this.mapService.currentProject,
            transform_group: tg,
        }, 'file_all', 'Dataset', 'PROJECT.DIALOG.ADD_TRANSFORM_TITLE', 'PROJECT.DIALOG.ADD_TRANSFORM_TEXT').subscribe((dest) => {
            if (this.debug) {
                console.log('layers.comp :: browseTT() -> file chosen (scene, file)', tg, dest);
            }
            if (dest instanceof _4d_mapper_1.Folder) {
                if (dest['root'] === 'myFiles')
                    dest.id = -1;
                tg.addImagesFromFolder(dest).subscribe((_) => {
                    this.mapService.scene.fetchObservable().subscribe();
                    this.refreshGroups();
                });
            }
            else if (dest && Array.isArray(dest)) {
                var ds = dest;
                var toAdd = [];
                let otherFilesAdded = 0;
                // this.mapComp.checkUploadRunningForDatasets(ds);
                if (this.debug) {
                    console.log('layers.comp :: browseTT() array[]', ds);
                }
                ds.filter((d) => d['canPlot'] && d.dataType.uid != 'photo').forEach((d) => d.transformIds.forEach((tid) => {
                    toAdd.push(tg.children.addObserveable(new _4d_mapper_1.Transform(this.fourD.V).set({ id: tid, __detected: { features: { isImageLayer: false } } })));
                    tg['layerProps'][map_service_1.MapService.TOGGLE + tid] = true;
                    tg['layerProps'][map_service_1.MapService.VIEW + tid] = true;
                    tg['layerProps'][map_service_1.MapService.ALPHA + tid] = 1;
                    tg.saveObservable().subscribe();
                }));
                ds.filter((d) => !d['canPlot']).forEach((file) => {
                    otherFilesAdded++;
                    if (this.mapService.scene && this.mapService.scene.folder) {
                        this.mapService.scene.folder.linkedFiles.addObserveable(file).subscribe();
                    }
                });
                ds.filter((d) => d.dataType && d.dataType.uid == 'photo').forEach((d) => d.transformIds.forEach((tid) => toAdd.push(tg.photos.addObserveable(new _4d_mapper_1.Transform(this.fourD.V).set({ id: tid })))));
                this.checkObjFileTransforms(dest, tg);
                if (toAdd.length) {
                    if (this.debug) {
                        console.log('layers.comp :: browseTT() array[]', toAdd);
                    }
                    rxjs_1.forkJoin(toAdd).subscribe((res) => {
                        if (this.debug) {
                            console.log('layers.comp :: browseTT() array[], after the forJoin()', res);
                        }
                        // to refresh the photo count once the upload is finished
                        this.mapService.scene.fetchObservable().subscribe();
                        this.refreshGroups(true);
                    });
                }
                if (otherFilesAdded) {
                    this.openSnackBarInfo('MAP.LAYERS.FILES_ADDED');
                    this.updateAdditionalFiles();
                }
                if (!otherFilesAdded && !toAdd.length) {
                    this.openSnackBarInfo('MAP.LAYERS.PLOTTABLE_ITEMS');
                }
            }
        }, (e) => this.openSnackBarError(e.message, null));
    }
    // added a crude case-insensitive string compare (@alex) should really go somewhere else, but is also
    // here because we test way too much against strings and further strings that are of various cases
    strCompareNocase(s1, s2) {
        s1 = (s1 + '').toLowerCase();
        s2 = (s2 + '').toLowerCase();
        return s1 > s2 ? 1 : s1 < s2 ? -1 : 1;
    }
    // if there is any obj file on which any job is run then fetch that job's transforms and add them in the scene. (I think @alex)
    checkObjFileTransforms(ds, tg) {
        if (this.debug) {
            console.log('layers.comp :: checkObjFileTransforms()', ds, tg);
        }
        let objDatasets = ds.filter((d) => d['currentJob']).map((d) => d);
        if (objDatasets.length > 0) {
            this.getJobData(objDatasets, tg, ds);
        }
    }
    // if there is any obj file on which any job is run then fetch that job's transforms and add them in the scene.
    getJobData(objDatasets, tg, dest) {
        Constants_1.Constants.showHangOn();
        let observables = objDatasets.map((dataset) => this.fourD.V.searchByObject(_4d_mapper_1.Job).equals('id', dataset['currentJob']).equals('current', null).limit(100013).queryObservable());
        rxjs_1.forkJoin(observables).subscribe((value) => {
            if (value && value.length > 0) {
                let toAdd = [];
                value.forEach((v) => {
                    if (v.items.length > 0) {
                        v.items[0]['transforms'].forEach((value) => {
                            if (value && value.id) {
                                toAdd.push(tg.children.addObserveable(new _4d_mapper_1.Transform(this.fourD.V).set({ id: value.id })));
                                tg['layerProps'][map_service_1.MapService.TOGGLE + value.id] = true;
                                tg['layerProps'][map_service_1.MapService.VIEW + value.id] = true;
                                tg['layerProps'][map_service_1.MapService.ALPHA + value.id] = 1;
                                tg.saveObservable().subscribe();
                            }
                        });
                    }
                });
                if (toAdd.length) {
                    rxjs_1.forkJoin(toAdd).subscribe((_) => {
                        this.mapService.scene.fetchObservable().subscribe();
                        this.refreshGroups(true);
                        Constants_1.Constants.hideHangOn();
                    });
                }
                else {
                    Constants_1.Constants.hideHangOn();
                }
            }
            else {
                Constants_1.Constants.hideHangOn();
            }
        });
    }
    drop(event) {
        if (this.debug) {
            console.log('layers :: drop()', event.previousIndex, event.currentIndex, this.mapService.sceneTransforms[event.previousIndex].transformType.uid, this.mapService.sceneTransforms[event.currentIndex].transformType.uid);
        }
        this.splitViewer.stop();
        this.tileProfiler.stop();
        if (this.mapService.terrainColorized) {
            this.openDialog(this.TERRAIN_COLORIZED_MESSAGE);
        }
        else {
            if (event.previousIndex !== event.currentIndex
            // && this.mapService.sceneTransforms
            // && this.mapService.sceneTransforms[event.previousIndex].transformType.uid === 'tms'
            // && this.mapService.sceneTransforms[event.currentIndex].transformType.uid === 'tms'
            ) {
                // if ( this.debug ) { console.log ( 'layers :: drop() before', this.mapService.sceneTransforms); }
                drag_drop_1.moveItemInArray(this.mapService.sceneTransforms, event.previousIndex, event.currentIndex);
                this.transformsOrderAndGroup();
                // if ( this.debug ) { console.log ( 'layers :: drop() after', this.mapService.sceneTransforms); }
            }
        }
    }
    deleteFromFile(d) {
        this.openConfirmDelete(() => d.destroyObservable().subscribe((s) => {
            this.updateAdditionalFiles();
            this.openSnackBarSuccess('FILE_LIST.DELETE.SUCCESS');
            this.incomingData.populateFromScene();
            this.refreshGroups(true);
        }, (e) => this.openSnackBarError('FILE_LIST.DELETE.ERROR')), d.name);
    }
    deleteFromScene(t) {
        this.openConfirmDelete(() => this.mapService.removeFromCurrentScene(t).subscribe((_) => {
            this.sceneController.plottedTransforms = this.sceneController.plottedTransforms.filter((s) => s.id != t.id);
            this.mapService.helper.removePlottable(t);
            this.openSnackBarSuccess('GENERIC.DELETE');
        }, (e) => this.openSnackBarError(e.message)), t.name);
    }
    nukePhotos() {
        this.openConfirmDelete(() => this.mapService.removeActiveScenePhotos().subscribe(), 'all photos');
    }
    deleteTransformGroup(tg) {
        this.openConfirmDelete(() => this.mapService.deleteScene(tg).subscribe((value) => {
            this.openSnackBarSuccess('GENERIC.DELETE');
        }), tg.name);
    }
    onFlyto(event) {
        if (this.debug) {
            console.log('layers.comp :: onFlyTo()');
        }
        if (event.transform)
            this.mapService.helper.sendCameraTo(event.transform);
    }
    saveScene() {
        if (this.sceneName.length > 0) {
            this.mapService.scene.name = this.sceneName;
            this.mapService.scene.saveObservable().subscribe();
        }
        else {
            this.sceneName = this.mapService.scene.name;
        }
    }
    // relocate to map.component.ts
    // renameScene(item) {
    //  const me = item.name;
    //  this.openDialog('SCENE.RENAME', null, 'GENERIC.SAVE', 'GENERIC.CANCEL', me).subscribe(res => {
    //   if (res) {
    //     item.name = res;
    //     item.saveObservable().subscribe();
    //   }
    // });
    // }
    waitForTerrainCompareResult(jobId) {
        if (this.debug) {
            console.log('layers.component :: waitForTerrainCompareResult()', jobId);
        }
        this.fourD.onSocketCommand('batch_transform_finished').subscribe((value) => {
            if (this.debug) {
                console.log('layers.component :: waitForTerrainCompareResult() batch_transform_finished', value, value && value.job == jobId);
            }
            if (value && value.job == jobId) {
                if (this.mapService.scenes.findIndex((s) => s.id === value.scene) === -1) {
                    this.mapService.loadScene(value.scene).subscribe();
                    this.openDialog('MAP.TERRAIN.TERRAIN_RESULT').subscribe();
                }
            }
        });
    }
    hasAdHocJobs(d) {
        // has _adhocs, is an array, array has items, and item [0] is not a null/false
        return d.dataType
            ? d.dataType._adhocTransforms && d.dataType._adhocTransforms.length
                ? d.dataType._adhocTransforms[0]
                    ? d.dataType._adhocTransforms.length
                    : 0
                : 0
            : 0;
    }
    startAdHocJob(d, datatypeId = null) {
        // no incoming transform data type? But we know there are some? Pick from the top ...
        if (!datatypeId && d.dataType._adhocTransforms.length) {
            datatypeId = d.dataType._adhocTransforms[0].id;
        }
        // find the type
        let type = d.dataType._adhocTransforms.find((f) => f.id == datatypeId);
        if (!type) {
            throw 'No transform datatype found';
        }
        let qMap = type['qMap'] ? type['qMap'] : null;
        var model = d['processingDefaultArgs'] || {};
        if (this.debug) {
            console.log('type, qmap, model', type, qMap, model);
        }
        // var types = this.fourD.datasetTypes.filter(t => t._adhocTransforms.length > 1)
        // console.log('## adHocJob', type, types, datatypeId, d, qMap, model );
        // return;
        this.service.startAdHoc(this.dialog, d, type, true).subscribe((s) => {
            if (this.debug) {
                console.log('done', s);
            }
        }, (e) => this.openSnackBarError('GENERIC.ERROR ' + e.message));
    }
    showInputDialogForT(model, tt) {
        let dialogRef = this.dialog.open(explorer_dialogs_1.APIDialog, {
            minWidth: '350px',
            // height: '80%',
            data: { model: model, apis: [tt], title: 'TYPES.' + tt.uid },
        });
        return dialogRef.afterClosed();
    }
    getCesiumObject(t) {
        let obj = this.mapService.helper.getCesiumObjectFor(t);
        if (!obj)
            return false;
        return obj;
    }
    // looks like it's never used? (@alex)
    enableCesiumeSceneGlobe(enable) {
        this.mapService.viewer.scene.globe.show = enable;
        this.mapService.viewer.skyAtmosphere = enable;
        this.mapService.viewer.scene.skyBox = new Cesium.SkyBox({
            show: enable,
        });
    }
    showHidePhotos(event) {
        this.mapService.showHideAllPhotosSub.next(event.currentTarget.checked);
    }
    flyToPhotos() {
        // if checkbox is not checked then return;
        if (!this.mapService.showPhotos[this.mapService.scene.id])
            return;
        this.router.navigate(['image'], { relativeTo: this.route });
        // flagging TODO; this doesn't inject coordinates
        this.mapService.refreshPhotos().subscribe((photos) => {
            // from all photos, pick the first
            if (photos.items && photos.items[0] && photos.items[0].llat && photos.items[0].llng) {
                this.mapService.helper.addPlottable(photos.items[0]).subscribe((_) => {
                    // now fly there!
                    this.mapService.viewer.zoomTo(this.mapService.helper.getCesiumObjectFor(photos.items[0]));
                });
            }
        });
    }
    changeOpacityAllTransform() {
        // list of layers to transform / play through
        let toChangeOpacityTransform = [];
        // for every layer
        this.mapService.sceneTransforms.forEach((ct) => {
            if (
            // is toggled 'on'
            this.mapService.scene['layerProps']['toggle_' + ct.id] &&
                // is a type that can be part of the fun (ie. has an opacity slider)
                this.mapService.isValidForChangingOpacity(ct)) {
                // add it to the list
                toChangeOpacityTransform.push(ct);
                this.mapService.scene['layerProps']['_alpha_' + ct.id] = false;
            }
        });
        if (this.debug) {
            console.log('layers.comp :: these layers is part of the transform', toChangeOpacityTransform);
        }
        // found any layers?
        if (toChangeOpacityTransform.length > 0) {
            this.mapComponent.isPlaying = true;
            this.mapComponent.cancelPlaying = false;
            this.mapComponent.pausePlaying = false;
            // this.mapComp.sidenav.close();
            // this.mapComp.disableCancelEvent = ()  => {this.cancel = true}
            // create a function to repeat
            var repeat = () => {
                this.iterateTransforms(toChangeOpacityTransform).subscribe((res) => {
                    if (this.debug) {
                        console.log('finished ', res);
                    }
                    if (this.mapComponent.repeatPlaying) {
                        // this.mapComp.disableCancelEvent = null
                        // reset alpha values back to the original
                        this.mapService.sceneTransforms.forEach((ct) => {
                            this.updateItem(ct);
                            this.mapService.scene['layerProps']['_alpha_' + ct.id] = false;
                        });
                        this.mapService.reorderTransform();
                        repeat();
                    }
                    else {
                        // this.mapComp.disableCancelEvent = null
                        // reset alpha values back to the original
                        this.mapService.sceneTransforms.forEach((ct) => {
                            this.updateItem(ct);
                            this.mapService.scene['layerProps']['_alpha_' + ct.id] = false;
                        });
                        this.mapService.reorderTransform();
                        this.mapComponent.isPlaying = false;
                        this.mapComponent.cancelPlaying = false;
                        this.mapComponent.pausePlaying = false;
                        // this.mapComp.playingSpeed = 0.01;
                        // this.mapComp.sidenav.open();
                    }
                });
            };
            // run the function
            repeat();
        }
        else {
            // no layers found that can be part of the fun
        }
    }
    // updateItem sets various properties of an item
    // for example, an image has a contrast set, or model has opacity, or a tileset is a wireframe
    updateItem(p, _saveSubj = null) {
        // when a new scene, look for old crap we want to remove
        let shouldUpdate = false;
        let found = [];
        ['plotty', 'entities'].forEach((key) => {
            if (p[key]) {
                shouldUpdate = true;
                p[key] = null;
                found.push(key);
            }
        });
        if (shouldUpdate) {
            try {
                p.saveObservable().subscribe((yay) => {
                    // console.log ( 'project ['+pid+'] updated / cleaned', p, found );
                }, (boo) => {
                    // console.log ( 'project ['+pid+'] updated / cleaned ERROR', p, found, boo );
                });
            }
            catch (error) {
                console.log('scene [' + p.id + '] updated / cleaned BIG ERROR', p, found, error);
            }
        }
        else {
            // console.log ( 'transform ['+p.id+'] cleaning', p, found );
        }
        // NOTE : change all occurences of 'fdm_features' into the newer '__detected'.'features' structure
        if (p['fdm_features']) {
            if (p['fdm_features']['canAlpha']) {
                // this.mapService.changeOpacity(p);
                this.sceneController.report(p.id, States_1.A.TRANSPARENT_ITEM, States_1.TURN.ON);
            }
            else {
                this.sceneController.report(p.id, States_1.A.TRANSPARENT_ITEM, States_1.TURN.OFF);
            }
            if (p['fdm_features']['isPointCloud']) {
                this.sceneController.report(p.id, States_1.A.POINTCLOUD, States_1.STATE.YES);
            }
            if (p['fdm_features']['isTerrain']) {
                this.sceneController.report(p.id, States_1.A.TERRAIN, States_1.STATE.YES);
            }
        }
        else {
            // console.log ( 'updateItem() NO_FEATURES', p );
        }
        if (p['wireframe']) {
            this.tilesetWireframe(p, p['wireframe']);
        }
        if (_saveSubj) {
            if (p['fdm_features'] && p['fdm_features']['canAlpha']) {
                this.mapService.changeOpacity(p, _saveSubj);
            }
            // if ( p.hasOwnProperty('clamping') ) {
            //   this.itemClamping(p, p['clamping'] );
            // }
            this.changeProperty('contrast', p, _saveSubj);
            this.changeProperty('gamma', p, _saveSubj);
            this.changeProperty('brightness', p, _saveSubj);
            this.changeProperty('saturation', p, _saveSubj);
        }
        this.updateHeight(p);
    }
    iterateTransforms(toChangeOpacityTransform) {
        var items = toChangeOpacityTransform.map((cur) => {
            return this.animateLayer(cur);
        });
        var subj = new rxjs_1.Subject();
        var rcur = () => {
            if (items.length && !this.mapComponent.cancelPlaying) {
                var cur = items[0];
                cur.subscribe((_) => rcur());
                items = items.filter((i) => i != cur);
            }
            else {
                subj.next('');
            }
        };
        rcur();
        return subj.asObservable();
    }
    animateLayer(ct) {
        return rxjs_1.of('').pipe(operators_1.flatMap((_) => {
            if (this.debug) {
                console.log('starting changing opacity ', ct.name, new Date());
            }
            this.mapComponent.currentPlayingTransform = ct.ds_name;
            var i = 1;
            var subj = new rxjs_1.Subject();
            var interval = setInterval(() => {
                if (this.mapComponent.pausePlaying && !this.mapComponent.cancelPlaying) {
                    // console.log('pausing');
                }
                else if (i >= 0 && !this.mapComponent.cancelPlaying) {
                    this.mapService.scene['layerProps']['_alpha_' + ct.id] = i;
                    this.mapService.changeOpacity(ct, undefined, { value: i });
                    i = i - this.mapComponent.playingSpeed;
                    // Apppl new opactiy
                }
                else {
                    // console.log('finished changing opacity ', ct.name, new Date(), i)
                    clearInterval(interval);
                    subj.next('hi');
                }
            }, this.scenTimeout / 200);
            return subj.asObservable();
        }) /*, tap(_ =>
          console.log('DONE!')
        )*/);
    }
    playerSetSpeed() {
        if (this.mapComponent.playingSpeed == 0.025) {
            this.mapComponent.playingSpeed = 0.0075;
        }
        else {
            this.mapComponent.playingSpeed += 0.005;
        }
        if (this.mapComponent.playingSpeedX == 4) {
            this.mapComponent.playingSpeedX = 0.5;
        }
        else if (this.mapComponent.playingSpeedX == 2) {
            this.mapComponent.playingSpeedX = 4;
        }
        else {
            this.mapComponent.playingSpeedX += 0.5;
        }
        // console.log(this.mapComp.playingSpeed)
    }
    cancelUploading(d) {
        this.fourD.uploadsRunningMap[d.id].uploader.cancel();
        d.destroyObservable().subscribe();
        // this.incomingData.remove(d); // refactoring the below line
        this.mapService.datasetForLayers.splice(this.mapService.datasetForLayers.findIndex((dd) => dd.id === d.id), 1);
    }
    deteteFromDatasetForLayers(d) {
        // this.incomingData.remove(d); // refactoring the below line
        this.mapService.datasetForLayers.splice(this.mapService.datasetForLayers.findIndex((dd) => dd.id === d.id), 1);
    }
    whatAmI(me) {
        console.log('WhatAmI', me);
    }
    adHoc(d, t) {
        this.service.startAdHoc(this.dialog, d, t, false).subscribe();
    }
}
exports.LayersListComponent = LayersListComponent;
